import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es6.array.find.js";
export var FAQ = [{
  language: 'fr-FR',
  url: 'https://faq-france.maisonsdumonde.com/fr/',
  contact: 'https://faq-france.maisonsdumonde.com/fr/articles/5140418-nous-contacter'
}, {
  language: 'fr-LU',
  url: 'https://faq-lux.maisonsdumonde.com/fr/',
  contact: 'https://faq-lux.maisonsdumonde.com/fr/articles/5336105-nous-contacter'
}, {
  language: 'en-GB',
  url: 'https://help-uk.maisonsdumonde.com/en/',
  contact: 'https://help-uk.maisonsdumonde.com/en/articles/5335769-contact-us'
}, {
  language: 'fr-BE',
  url: 'https://faq-belgique.maisonsdumonde.com/fr/',
  contact: 'https://faq-belgique.maisonsdumonde.com/fr/articles/5336103-nous-contacter'
}, {
  language: 'nl-BE',
  url: 'https://faq-belgie.maisonsdumonde.com/nl/',
  contact: 'https://faq-belgie.maisonsdumonde.com/nl/articles/5335276-contact-ons'
}, {
  language: 'nl-NL',
  url: 'https://faq-nederland.maisonsdumonde.com/nl/',
  contact: 'https://faq-nederland.maisonsdumonde.com/nl/articles/5335118-contact-ons'
}, {
  language: 'de-DE',
  url: 'https://faq-deutschland.maisonsdumonde.com/de/',
  contact: 'https://faq-deutschland.maisonsdumonde.com/de/articles/5335178-kontaktieren-sie-uns'
}, {
  language: 'de-AT',
  url: 'https://faq-oesterreich.maisonsdumonde.com/de/',
  contact: 'https://faq-oesterreich.maisonsdumonde.com/de/articles/5335180-kontaktieren-sie-uns'
}, {
  language: 'it-CH',
  url: 'https://faq-svizzera.maisonsdumonde.com/it/',
  contact: 'https://faq-svizzera.maisonsdumonde.com/it/articles/5332704-contattarci'
}, {
  language: 'fr-CH',
  url: 'https://faq-suisse.maisonsdumonde.com/fr/',
  contact: 'https://faq-suisse.maisonsdumonde.com/fr/articles/5336104-nous-contacter'
}, {
  language: 'de-CH',
  url: 'https://faq-schweiz.maisonsdumonde.com/de/',
  contact: 'https://faq-schweiz.maisonsdumonde.com/de/articles/5335179-kontaktieren-sie-uns'
}, {
  language: 'es-ES',
  url: 'https://faq-es.maisonsdumonde.com/es/',
  contact: 'https://faq-es.maisonsdumonde.com/es/articles/5089970-contactarnos'
}, {
  language: 'it-IT',
  url: 'https://faq-italia.maisonsdumonde.com/it/',
  contact: 'https://faq-italia.maisonsdumonde.com/it/articles/5332703-contattarci'
}, {
  language: 'pt-PT',
  url: 'https://help-pt.maisonsdumonde.com/pt/',
  contact: 'https://help-pt.maisonsdumonde.com/pt/articles/5332701-contacte-nos'
}];
export var TERMS_CONDITIONS_PRO = [{
  language: 'de-DE',
  label: 'Allgemeine Geschäftsbedingungen Geschäftskunden'
}, {
  language: 'fr-FR',
  label: 'CGV Business'
}, {
  language: 'fr-LU',
  label: 'CGV Business'
}, {
  language: 'en-GB',
  label: 'General terms of sale professionals'
}, {
  language: 'fr-BE',
  label: 'CGV Business'
}, {
  language: 'nl-BE',
  label: 'Algemene verkoopvoorwaarden professionals'
}, {
  language: 'it-CH',
  label: 'Condizioni generali di vendita professionisti'
}, {
  language: 'fr-CH',
  label: 'CGV Business'
}, {
  language: 'de-CH',
  label: 'Allgemeine Geschäftsbedingungen Geschäftskunden'
}, {
  language: 'es-ES',
  label: 'CGV profesionales'
}, {
  language: 'it-IT',
  label: 'Condizioni generali di vendita professionisti'
}];
export var FAQ_URL = {
  'fr-FR': 'https://faq-france.maisonsdumonde.com',
  'fr-LU': 'https://faq-lux.maisonsdumonde.com',
  'en-GB': 'https://help-uk.maisonsdumonde.com',
  'fr-BE': 'https://faq-belgique.maisonsdumonde.com',
  'nl-BE': 'https://faq-belgie.maisonsdumonde.com',
  'nl-NL': 'https://faq-nederland.maisonsdumonde.com',
  'de-DE': 'https://faq-deutschland.maisonsdumonde.com',
  'de-AT': 'https://faq-oesterreich.maisonsdumonde.com',
  'it-CH': 'https://faq-svizzera.maisonsdumonde.com',
  'fr-CH': 'https://faq-suisse.maisonsdumonde.com',
  'de-CH': 'https://faq-schweiz.maisonsdumonde.com',
  'es-ES': 'https://faq-es.maisonsdumonde.com',
  'it-IT': 'https://faq-italia.maisonsdumonde.com',
  'pt-PT': 'https://help-pt.maisonsdumonde.com'
};
export var DELIVERY_FAQ = {
  'fr-FR': {
    deliveryUrl: "".concat(FAQ_URL['fr-FR'], "/fr/collections/1235252-livraison")
  },
  'fr-LU': {
    deliveryUrl: "".concat(FAQ_URL['fr-LU'], "/fr/collections/1474490-livraison")
  },
  'en-GB': {
    deliveryUrl: "".concat(FAQ_URL['en-GB'], "/en/collections/1223095-delivery")
  },
  'fr-BE': {
    deliveryUrl: "".concat(FAQ_URL['fr-BE'], "/fr/collections/1407218-livraison")
  },
  'nl-BE': {
    deliveryUrl: "".concat(FAQ_URL['nl-BE'], "/nl/collections/1464304-levering")
  },
  'nl-NL': {
    deliveryUrl: "".concat(FAQ_URL['nl-NL'], "/nl/collections/1469850-levering")
  },
  'de-DE': {
    deliveryUrl: "".concat(FAQ_URL['de-DE'], "/de/collections/1462565-lieferung")
  },
  'de-AT': {
    deliveryUrl: "".concat(FAQ_URL['de-AT'], "/de/collections/1471417-lieferung")
  },
  'it-CH': {
    deliveryUrl: "".concat(FAQ_URL['it-CH'], "/it/collections/1460829-consegna")
  },
  'fr-CH': {
    deliveryUrl: "".concat(FAQ_URL['fr-CH'], "/fr/collections/1413246-livraison")
  },
  'de-CH': {
    deliveryUrl: "".concat(FAQ_URL['de-CH'], "/de/collections/1466189-lieferung")
  },
  'es-ES': {
    deliveryUrl: "".concat(FAQ_URL['es-ES'], "/es/collections/1440575-envio")
  },
  'it-IT': {
    deliveryUrl: "".concat(FAQ_URL['it-IT'], "/it/collections/1432865-consegna")
  },
  'pt-PT': {
    deliveryUrl: "".concat(FAQ_URL['pt-PT'], "/pt/collections/1472882-envio")
  }
};
export var RETURN_FAQ = {
  'fr-FR': {
    returnsUrl: "".concat(FAQ_URL['fr-FR'], "/fr/collections/1235271-retour-et-remboursement")
  },
  'fr-LU': {
    returnsUrl: "".concat(FAQ_URL['fr-LU'], "/fr/collections/1474497-retour-et-remboursement")
  },
  'en-GB': {
    returnsUrl: "".concat(FAQ_URL['en-GB'], "/en/collections/1223125-refunds-returns")
  },
  'fr-BE': {
    returnsUrl: "".concat(FAQ_URL['fr-BE'], "/fr/collections/1410739-retour-et-remboursement")
  },
  'nl-BE': {
    returnsUrl: "".concat(FAQ_URL['nl-BE'], "/nl/collections/1464319-retourneren-en-terugbetaling")
  },
  'nl-NL': {
    returnsUrl: "".concat(FAQ_URL['nl-NL'], "/nl/collections/1469867-retourneren-en-terugbetaling")
  },
  'de-DE': {
    returnsUrl: "".concat(FAQ_URL['de-DE'], "/de/collections/1462573-retouren-und-erstattungen")
  },
  'de-AT': {
    returnsUrl: "".concat(FAQ_URL['de-AT'], "/de/collections/1471424-retouren-und-erstattungen")
  },
  'it-CH': {
    returnsUrl: "".concat(FAQ_URL['it-CH'], "/it/collections/1460838-resi-e-rimborsi")
  },
  'fr-CH': {
    returnsUrl: "".concat(FAQ_URL['fr-CH'], "/fr/collections/1413252-retour-et-remboursement")
  },
  'de-CH': {
    returnsUrl: "".concat(FAQ_URL['de-CH'], "/de/collections/1466199-retouren-und-erstattungen")
  },
  'es-ES': {
    returnsUrl: "".concat(FAQ_URL['es-ES'], "/es/collections/1440576-devolucion-y-reembolso")
  },
  'it-IT': {
    returnsUrl: "".concat(FAQ_URL['it-IT'], "/it/collections/1433177-resi-e-rimborsi")
  },
  'pt-PT': {
    returnsUrl: "".concat(FAQ_URL['pt-PT'], "/pt/collections/1472887-devolucao-e-reembolso")
  }
};
export var MODULE_FAQ = [{
  language: 'fr-FR',
  questions: {
    HOTTOPICS: [{
      url: "".concat(FAQ_URL['fr-FR'], "/livraison"),
      label: 'Livraison'
    }, {
      url: "".concat(FAQ_URL['fr-FR'], "/retour-et-remboursement"),
      label: 'Retour et remboursement'
    }, {
      url: "".concat(FAQ_URL['fr-FR'], "/produits-et-disponibilite"),
      label: 'Produit et disponibilité'
    }],
    HOME: [{
      url: "".concat(FAQ_URL['fr-FR'], "/articles/2370783-quel-transporteur-va-me-livrer"),
      label: 'Quel transporteur va me livrer ?'
    }, {
      url: "".concat(FAQ_URL['fr-FR'], "/articles/2158893-quel-est-le-montant-des-frais-de-livraison"),
      label: 'Quel est le montant des frais de livraison ?'
    }, {
      url: "".concat(FAQ_URL['fr-FR'], "/fr/articles/4929096-comment-contacter-mon-vendeur-marketplace"),
      label: 'Comment contacter mon vendeur Marketplace ?'
    }],
    ORDERS: [{
      url: "".concat(FAQ_URL['fr-FR'], "/articles/2364207-quels-sont-les-delais-et-modes-de-remboursement"),
      label: 'Quels sont les délais et modes de remboursement ?'
    }, {
      url: "".concat(FAQ_URL['fr-FR'], "/articles/2159083-puis-je-echanger-en-magasin-un-meuble-commande-par-internet"),
      label: 'Puis-je échanger en magasin un article commandé sur internet ?'
    }, {
      url: "".concat(FAQ_URL['fr-FR'], "/fr/articles/4929096-comment-contacter-mon-vendeur-marketplace"),
      label: 'Comment contacter mon vendeur Marketplace ?'
    }],
    ORDERDETAILS: [{
      url: "".concat(FAQ_URL['fr-FR'], "/articles/2362321-colissimo-point-de-retrait-quels-sont-les-delais-et-modalites-d-une-livraison"),
      label: 'Colissimo: quels sont les délais et modalités de livraison?'
    }, {
      url: "".concat(FAQ_URL['fr-FR'], "/articles/2362347-geodis-quels-sont-les-delais-et-modalites-d-une-livraison"),
      label: 'Geodis: quels sont les délais et modalités de livraison?'
    }],
    GIFTS: [{
      url: "".concat(FAQ_URL['fr-FR'], "/articles/2353042-existe-il-une-carte-de-fidelite-maisons-du-monde"),
      label: 'Existe-t-il une carte de fidélité Maisons du Monde?'
    }, {
      url: "".concat(FAQ_URL['fr-FR'], "/articles/2349682-je-n-arrive-pas-a-utiliser-ma-carte-cadeau"),
      label: "Je n'arrive pas à utiliser ma carte cadeau"
    }],
    PROFILE: [{
      url: "".concat(FAQ_URL['fr-FR'], "/articles/2159100-comment-puis-je-exercer-mes-droits-en-matiere-de-protection-de-mes-donnees-personnelles"),
      label: 'Comment puis-je exercer mes droits en matière de protection de mes données personnelles?'
    }, {
      url: "".concat(FAQ_URL['fr-FR'], "/articles/2118905-comment-me-desabonner-de-la-newsletter"),
      label: 'Comment me désabonner de la newsletter?'
    }],
    SHIPPINGDETAILS: [{
      url: "".concat(FAQ_URL['fr-FR'], "/livraison")
    }],
    OTHERQUESTION: [{
      url: "".concat(FAQ_URL['fr-FR'], "/livraison")
    }],
    EXCHANGEPRODUCT: [{
      url: "".concat(FAQ_URL['fr-FR'], "/livraison")
    }]
  }
}, {
  language: 'fr-LU',
  questions: {
    HOTTOPICS: [{
      url: "".concat(FAQ_URL['fr-LU'], "/fr/collections/1474490-livraison"),
      label: 'Livraison'
    }, {
      url: "".concat(FAQ_URL['fr-LU'], "/fr/collections/1474497-retour-et-remboursement"),
      label: 'Retour et remboursement'
    }, {
      url: "".concat(FAQ_URL['fr-LU'], "/fr/collections/1409065-produits-et-disponibilite"),
      label: 'Produit et disponibilité'
    }],
    HOME: [{
      url: "".concat(FAQ_URL['fr-LU'], "/articles/2550988-quel-transporteur-va-me-livrer"),
      label: 'Quel transporteur va me livrer?'
    }, {
      url: "".concat(FAQ_URL['fr-LU'], "/articles/2550938-quel-est-le-montant-des-frais-de-livraison"),
      label: 'Quel est le montant des frais de livraison?'
    }],
    ORDERS: [{
      url: "".concat(FAQ_URL['fr-LU'], "/articles/2551352-quels-sont-les-delais-et-modes-de-remboursement"),
      label: 'Quels sont les délais et modes de remboursement ?'
    }, {
      url: "".concat(FAQ_URL['fr-LU'], "/articles/2550950-quels-sont-les-delais-et-modalites-d-une-livraison-en-magasin"),
      label: "Quels sont les délais et modalités d'une livraison en magasin?"
    }],
    ORDERDETAILS: [{
      url: "".concat(FAQ_URL['fr-LU'], "/articles/2550962-colissimo-dpd-quels-sont-les-delais-et-modalites-d-une-livraison"),
      label: 'Colissimo/DPD : quels sont les délais et modalités de livraison ?'
    }, {
      url: "".concat(FAQ_URL['fr-LU'], "/fr/articles/2875395-puis-je-retourner-en-magasin-un-article-commande-sur-internet"),
      label: 'Puis-je échanger en magasin un article commandé sur internet ?'
    }],
    GIFTS: [{
      url: "".concat(FAQ_URL['fr-LU'], "/articles/2550179-je-souhaite-offrir-une-carte-cadeau"),
      label: 'Je souhaite offrir une carte cadeau.'
    }, {
      url: "".concat(FAQ_URL['fr-LU'], "/articles/2550153-comment-utiliser-ma-carte-cadeau"),
      label: 'Comment utliser ma carte cadeau '
    }],
    PROFILE: [{
      url: "".concat(FAQ_URL['fr-LU'], "/articles/2550130-comment-puis-je-exercer-mes-droits-en-matiere-de-protection-de-mes-donnees-personnelles"),
      label: 'Comment puis-je exercer mes droits en matière de protection de mes données personnelles?'
    }, {
      url: "".concat(FAQ_URL['fr-LU'], "/articles/2550393-je-n-ai-pas-recu-mon-e-mail-de-confirmation-ou-d-expedition-de-commande"),
      label: "Je n'ai pas reçu mon e-mail de confirmation ou d'expédition de commande."
    }],
    SHIPPINGDETAILS: [{
      url: "".concat(FAQ_URL['fr-LU'], "/fr/collections/1474490-livraison',")
    }],
    OTHERQUESTION: [{
      url: "".concat(FAQ_URL['fr-LU'], "/fr/collections/1474490-livraison")
    }],
    EXCHANGEPRODUCT: [{
      url: "".concat(FAQ_URL['fr-LU'], "/fr/collections/1474490-livraison")
    }]
  }
}, {
  language: 'en-GB',
  questions: {
    HOTTOPICS: [{
      url: "".concat(FAQ_URL['en-GB'], "/en/collections/1223095-delivery"),
      label: 'Delivery'
    }, {
      url: "".concat(FAQ_URL['en-GB'], "/en/collections/1223125-refunds-returns"),
      label: 'Refunds & returns'
    }, {
      url: "".concat(FAQ_URL['en-GB'], "/en/collections/1223108-products-availability"),
      label: 'Products & availability'
    }],
    HOME: [{
      url: "".concat(FAQ_URL['en-GB'], "/articles/2281868-what-are-the-delivery-costs"),
      label: 'What are the delivery costs?'
    }, {
      url: "".concat(FAQ_URL['en-GB'], "/articles/2281872-what-are-the-delivery-regions-for-maisons-du-monde"),
      label: 'What are the delivery regions for Maisons du Monde?'
    }],
    ORDERS: [{
      url: "".concat(FAQ_URL['en-GB'], "/articles/2346448-how-and-when-am-i-refunded"),
      label: 'How and when am I refunded?'
    }, {
      url: "".concat(FAQ_URL['en-GB'], "/articles/2346435-will-delivery-fees-be-refunded"),
      label: 'Will delivery fees be refunded?'
    }],
    ORDERDETAILS: [{
      url: "".concat(FAQ_URL['en-GB'], "/articles/2283861-i-want-to-return-a-product-that-i-ordered-online"),
      label: 'I want to return a product that I ordered online?'
    }, {
      url: "".concat(FAQ_URL['en-GB'], "/articles/2282778-dhl-what-are-the-times-and-terms-of-delivery"),
      label: 'DHL : what are the times and terms of delivery ?'
    }],
    GIFTS: [{
      url: "".concat(FAQ_URL['en-GB'], "/articles/2281394-how-do-i-use-my-voucher"),
      label: 'How do I use my voucher?'
    }, {
      url: "".concat(FAQ_URL['en-GB'], "/articles/2281410-i-have-not-received-my-voucher-that-was-sent-by-email-or-post"),
      label: 'I have not received my voucher that was sent by email or post.'
    }],
    PROFILE: [{
      url: "".concat(FAQ_URL['en-GB'], "/articles/2282729-how-can-i-exercise-my-rights-for-my-personal-data"),
      label: 'How can I exercise my rights for my personal data?'
    }, {
      url: "".concat(FAQ_URL['en-GB'], "/articles/2281784-i-want-to-change-my-delivery-address"),
      label: 'I want to change my delivery address'
    }],
    SHIPPINGDETAILS: [{
      url: "".concat(FAQ_URL['en-GB'], "/en/collections/1223095-delivery")
    }],
    OTHERQUESTION: [{
      url: "".concat(FAQ_URL['en-GB'], "/en/collections/1223095-delivery")
    }],
    EXCHANGEPRODUCT: [{
      url: "".concat(FAQ_URL['en-GB'], "/en/collections/1223095-delivery")
    }]
  }
}, {
  language: 'fr-BE',
  questions: {
    HOTTOPICS: [{
      url: "".concat(FAQ_URL['fr-BE'], "/fr/collections/1407218-livraison"),
      label: 'Livraison'
    }, {
      url: "".concat(FAQ_URL['fr-BE'], "/fr/collections/1410739-retour-et-remboursement"),
      label: 'Retour et remboursement'
    }, {
      url: "".concat(FAQ_URL['fr-BE'], "/fr/collections/1400253-produits-et-disponibilite"),
      label: 'Produit et disponibilité'
    }],
    HOME: [{
      url: "".concat(FAQ_URL['fr-BE'], "/articles/2443592-quel-est-le-montant-des-frais-de-livraison"),
      label: 'Quel est le montant des frais de livraison ?'
    }, {
      url: "".concat(FAQ_URL['fr-BE'], "/articles/2443533-est-il-possible-de-me-faire-livrer-en-magasin"),
      label: 'Est-il possible de me faire livrer en magasin?'
    }],
    ORDERS: [{
      url: "".concat(FAQ_URL['fr-BE'], "/articles/2443786-quels-sont-les-delais-et-modes-de-remboursement"),
      label: 'Quels sont les délais et modes de remboursement ?'
    }, {
      url: "".concat(FAQ_URL['fr-BE'], "/articles/2443602-quels-sont-les-delais-et-modalites-d-une-livraison-en-magasin"),
      label: "Quels sont les délais et modalités d'une livraison en magaisn?"
    }],
    ORDERDETAILS: [{
      url: "".concat(FAQ_URL['fr-BE'], "/articles/2443613-colissimo-quels-sont-les-delais-et-modalites-d-une-livraison"),
      label: "Colissimo : quels sont les délais et modalités d'une livraison ?"
    }, {
      url: "".concat(FAQ_URL['fr-BE'], "/articles/2791350-ab-custom-quels-sont-les-delais-et-modalites-d-une-livraison"),
      label: "Ab Custom : quels sont les délais et modalités d'une livraison ?"
    }],
    GIFTS: [{
      url: "".concat(FAQ_URL['fr-BE'], "/articles/2442769-je-souhaite-offrir-une-carte-cadeau"),
      label: 'Je souhaite offrir une carte cadeau?'
    }, {
      url: "".concat(FAQ_URL['fr-BE'], "/articles/2440862-comment-utiliser-ma-carte-cadeau"),
      label: 'Comment utiliser ma carte cadeau ?'
    }],
    PROFILE: [{
      url: "".concat(FAQ_URL['fr-BE'], "/articles/2443344-comment-puis-je-exercer-mes-droits-en-matiere-de-protection-de-mes-donnees-personnelles"),
      label: 'Comment puis-je exercer mes droits en matière de protection de mes données personnelles ?'
    }, {
      url: "".concat(FAQ_URL['fr-BE'], "/articles/2417847-je-n-ai-pas-recu-mon-e-mail-de-confirmation-ou-d-expedition-de-commande"),
      label: "Je n'ai pas reçu mon e-mail de confirmation ou d'expédition de commande."
    }],
    SHIPPINGDETAILS: [{
      url: "".concat(FAQ_URL['fr-BE'], "/fr/collections/1407218-livraison")
    }],
    OTHERQUESTION: [{
      url: "".concat(FAQ_URL['fr-BE'], "/fr/collections/1407218-livraison")
    }],
    EXCHANGEPRODUCT: [{
      url: "".concat(FAQ_URL['fr-BE'], "/fr/collections/1407218-livraison")
    }]
  }
}, {
  language: 'nl-BE',
  questions: {
    HOTTOPICS: [{
      url: "".concat(FAQ_URL['nl-BE'], "/nl/collections/1464304-levering"),
      label: 'Levering'
    }, {
      url: "".concat(FAQ_URL['nl-BE'], "/nl/collections/1464319-retourneren-en-terugbetaling"),
      label: 'Retourneren en terugbetaling'
    }, {
      url: "".concat(FAQ_URL['nl-BE'], "/nl/collections/1407212-producten-en-verkrijgbaarheid"),
      label: 'Producten en verkrijgbaarheid'
    }],
    HOME: [{
      url: "".concat(FAQ_URL['nl-BE'], "/articles/2535827-kan-ik-mijn-bestelling-in-de-winkel-laten-bezorgen"),
      label: 'Kan ik mijn bestelling in de winkel laten bezorgen?'
    }, {
      url: "".concat(FAQ_URL['nl-BE'], "/articles/2535851-welke-transporteur-zal-mijn-bestelling-leveren"),
      label: 'Welke transporteur zal mijn bestelling leveren?'
    }],
    ORDERS: [{
      url: "".concat(FAQ_URL['nl-BE'], "/articles/2535828-wat-zijn-de-leveringstermijnen-en-voorwaarden-in-de-winkel"),
      label: 'Wat zijn de leveringstermijnen en -voorwaarden in de winkel?'
    }, {
      url: "".concat(FAQ_URL['nl-BE'], "/articles/2536019-wat-zijn-de-termijnen-en-methoden-voor-terugbetalingen"),
      label: 'Wat zijn de termijnen en methoden voor terugbetalingen?'
    }],
    ORDERDETAILS: [{
      url: "".concat(FAQ_URL['nl-BE'], "/articles/2535835-chronopost-dpd-wat-zijn-de-leveringstermijnen-en-voorwaarden"),
      label: 'Chronopost / DPD: wat zijn de leveringstermijnen en -voorwaarden?'
    }, {
      url: "".concat(FAQ_URL['nl-BE'], "/articles/2535845-colissimo-bpost-wat-zijn-de-leveringstermijnen-en-voorwaarden"),
      label: 'Colissimo / Bpost: wat zijn de leveringstermijnen en -voorwaarden?'
    }],
    GIFTS: [{
      url: "".concat(FAQ_URL['nl-BE'], "/articles/2535656-hoe-kan-ik-mijn-cadeaubon-gebruiken"),
      label: 'Hoe kan ik mijn cadeaubon gebruiken?'
    }, {
      url: 'https://app.intercom.io/a/apps/heeerdnj/articles/articles/2535681/show',
      label: 'Ik kan mijn cadeaukaart niet gebruiken.'
    }],
    PROFILE: [{
      url: "".concat(FAQ_URL['nl-BE'], "/articles/2532980-hoe-kan-ik-mijn-rechten-uitoefenen-om-mijn-persoonlijke-gegevens-te-beschermen"),
      label: 'Hoe kan ik mijn rechten uitoefenen om mijn persoonlijke gegevens te beschermen?'
    }, {
      url: "".concat(FAQ_URL['nl-BE'], "/articles/2533102-ik-heb-geen-bevestigingsmail-of-verzendbevestiging-ontvangen"),
      label: 'Ik heb geen bevestigingsmail of verzendbevestiging ontvangen.'
    }],
    SHIPPINGDETAILS: [{
      url: "".concat(FAQ_URL['nl-BE'], "/nl/collections/1464304-levering")
    }],
    OTHERQUESTION: [{
      url: "".concat(FAQ_URL['nl-BE'], "/nl/collections/1464304-levering")
    }],
    EXCHANGEPRODUCT: [{
      url: "".concat(FAQ_URL['nl-BE'], "/nl/collections/1464304-levering")
    }]
  }
}, {
  language: 'nl-NL',
  questions: {
    HOTTOPICS: [{
      url: "".concat(FAQ_URL['nl-NL'], "/nl/collections/1469850-levering"),
      label: 'Levering'
    }, {
      url: "".concat(FAQ_URL['nl-NL'], "/nl/collections/1469867-retourneren-en-terugbetaling"),
      label: 'Retourneren en terugbetaling'
    }, {
      url: "".concat(FAQ_URL['nl-NL'], "/nl/collections/1410533-producten-en-verkrijgbaarheid"),
      label: 'Producten en verkrijgbaarheid'
    }],
    HOME: [{
      url: "".concat(FAQ_URL['nl-NL'], "/articles/2543838-hoeveel-bedragen-de-verzendkosten"),
      label: 'Hoeveel bedragen de verzendkosten?'
    }, {
      url: "".concat(FAQ_URL['nl-NL'], "/articles/2543877-welke-transporteur-zal-mijn-bestelling-leveren"),
      label: 'Welke transporteur zal mijn bestelling leveren?'
    }],
    ORDERS: [{
      url: "".concat(FAQ_URL['nl-NL'], "/articles/2544055-wat-zijn-de-termijnen-en-methoden-voor-terugbetalingen"),
      label: 'Wat zijn de termijnen en methoden voor terugbetalingen?'
    }, {
      url: "".concat(FAQ_URL['nl-NL'], "/articles/2544045-worden-mijn-verzendkosten-terugbetaald"),
      label: 'Worden mijn verzendkosten terugbetaald?'
    }],
    ORDERDETAILS: [{
      url: "".concat(FAQ_URL['nl-NL'], "/articles/2543863-chronopost-dpd-wat-zijn-de-leveringstermijnen-en-voorwaarden"),
      label: 'Chronopost/DPD: wat zijn de leveringstermijnen en -voorwaarden?'
    }, {
      url: "".concat(FAQ_URL['nl-NL'], "/articles/2543999-ik-wil-mijn-pakket-retourneren-en-de-terugbetalingsvoorwaarden-kennen"),
      label: 'Ik wil mijn pakket retourneren en de terugbetalingsvoorwaarden kennen.'
    }],
    GIFTS: [{
      url: "".concat(FAQ_URL['nl-NL'], "/articles/2541610-hoe-kan-ik-mijn-cadeaubon-gebruiken"),
      label: 'Hoe kan ik mijn cadeaubon gebruiken?'
    }, {
      url: "".concat(FAQ_URL['nl-NL'], "/articles/2541706-hoe-kan-ik-mijn-aankoopbon-gebruiken"),
      label: 'Hoe kan ik mijn aankoopbon gebruiken?'
    }],
    PROFILE: [{
      url: "".concat(FAQ_URL['nl-NL'], "/articles/2541589-hoe-kan-ik-mijn-rechten-uitoefenen-om-mijn-persoonlijke-gegevens-te-beschermen"),
      label: 'Hoe kan ik mijn rechten uitoefenen om mijn persoonlijke gegevens te beschermen?'
    }, {
      url: "".concat(FAQ_URL['nl-NL'], "/articles/2541840-ik-heb-geen-bevestigingsmail-of-verzendbevestiging-ontvangen"),
      label: 'Ik heb geen bevestigingsmail of verzendbevestiging ontvangen.'
    }],
    SHIPPINGDETAILS: [{
      url: "".concat(FAQ_URL['nl-NL'], "/nl/collections/1469850-levering")
    }],
    OTHERQUESTION: [{
      url: "".concat(FAQ_URL['nl-NL'], "/nl/collections/1469850-levering")
    }],
    EXCHANGEPRODUCT: [{
      url: "".concat(FAQ_URL['nl-NL'], "/nl/collections/1469850-levering")
    }]
  }
}, {
  language: 'de-DE',
  questions: {
    HOTTOPICS: [{
      url: "".concat(FAQ_URL['de-DE'], "/de/collections/1462565-lieferung"),
      label: 'Lieferung'
    }, {
      url: "".concat(FAQ_URL['de-DE'], "/de/collections/1462573-retouren-und-erstattungen"),
      label: 'Retouren und Erstattungen'
    }, {
      url: "".concat(FAQ_URL['de-DE'], "/de/collections/1410537-artikel-und-verfugbarkeit"),
      label: 'Artikel und Verfügbarkeit'
    }],
    HOME: [{
      url: "".concat(FAQ_URL['de-DE'], "/articles/2532705-wie-hoch-sind-die-lieferkosten"),
      label: 'Wie hoch sind die Lieferkosten?'
    }, {
      url: "".concat(FAQ_URL['de-DE'], "/articles/2532781-welcher-spediteur-wird-mich-beliefern"),
      label: 'Welcher Spediteur wird mich beliefern?'
    }],
    ORDERS: [{
      url: "".concat(FAQ_URL['de-DE'], "/articles/2530996-welche-fristen-und-bedingungen-gelten-fur-die-erstattung"),
      label: 'Welche Fristen und Bedingungen gelten für die Erstattung?'
    }, {
      url: "".concat(FAQ_URL['de-DE'], "articles/2530979-werden-meine-lieferkosten-erstattet"),
      label: 'Werden meine Lieferkosten erstattet?'
    }],
    ORDERDETAILS: [{
      url: "".concat(FAQ_URL['de-DE'], "/articles/2532741-colissimo-dpd-welche-lieferzeit-und-bedingungen-gelten-fur-die-lieferung"),
      label: 'Colissimo/DPD : welche Fristen und Bedingungen gelten für die Lieferung?'
    }, {
      url: "".concat(FAQ_URL['de-DE'], "/articles/2532768-dhl-welche-lieferzeit-und-bedingungen-gelten-fur-die-lieferung"),
      label: 'DHL: welche Fristen und Bedingungen gelten für die Lieferung?'
    }],
    GIFTS: [{
      url: "".concat(FAQ_URL['de-DE'], "/articles/2530415-wie-kann-ich-meinen-gutschein-einlosen"),
      label: 'Wie kann ich meinen Gutschein einlösen?'
    }, {
      url: "".concat(FAQ_URL['de-DE'], "/articles/2530178-wie-kann-ich-meine-geschenkkarte-einlosen"),
      label: 'Wie kann ich meine Geschenkkarte einlösen?'
    }],
    PROFILE: [{
      url: "".concat(FAQ_URL['de-DE'], "/articles/2529806-wie-kann-ich-meine-rechte-bezuglich-des-schutzes-meiner-personenbezogenen-daten-ausuben"),
      label: 'Wie kann ich meine Rechte bezüglich des Schutzes meiner personenbezogenen Daten ausüben?'
    }, {
      url: "".concat(FAQ_URL['de-DE'], "/articles/2529847-ich-habe-mein-passwort-vergessen-was-kann-ich-tun"),
      label: 'Ich habe mein Passwort vergessen, was kann ich tun?'
    }],
    SHIPPINGDETAILS: [{
      url: "".concat(FAQ_URL['de-DE'], "/de/collections/1462565-lieferung")
    }],
    OTHERQUESTION: [{
      url: "".concat(FAQ_URL['de-DE'], "/de/collections/1462565-lieferung")
    }],
    EXCHANGEPRODUCT: [{
      url: "".concat(FAQ_URL['de-DE'], "/de/collections/1462565-lieferung")
    }]
  }
}, {
  language: 'de-AT',
  questions: {
    HOTTOPICS: [{
      url: "".concat(FAQ_URL['de-AT'], "/de/collections/1471417-lieferung"),
      label: 'Lieferung'
    }, {
      url: "".concat(FAQ_URL['de-AT'], "/de/collections/1471424-retouren-und-erstattungen"),
      label: 'Retouren und Erstattungen'
    }, {
      url: "".concat(FAQ_URL['de-AT'], "/de/collections/1410541-artikel-und-verfugbarkeit"),
      label: 'Artikel und Verfügbarkeit'
    }],
    HOME: [{
      url: "".concat(FAQ_URL['de-AT'], "/articles/2544751-wie-hoch-sind-die-lieferkosten"),
      label: 'Wie hoch sind die Lieferkosten?'
    }, {
      url: "".concat(FAQ_URL['de-AT'], "/articles/2544755-wohin-liefert-maisons-du-monde"),
      label: 'Wohin liefert Maisons du Monde?'
    }],
    ORDERS: [{
      url: "".concat(FAQ_URL['de-AT'], "/articles/2544781-welcher-spediteur-wird-mich-beliefern"),
      label: 'Welcher Spediteur wird mich beliefern?'
    }, {
      url: "".concat(FAQ_URL['de-AT'], "/articles/2546837-welche-fristen-und-bedingungen-gelten-fur-die-erstattung"),
      label: 'Welche Fristen und Bedingungen gelten für die Erstattung??'
    }],
    ORDERDETAILS: [{
      url: "".concat(FAQ_URL['de-AT'], "/articles/2546850-ich-mochte-mein-paket-zuruckschicken-und-mich-uber-die-erstattungsbedingungen-informieren"),
      label: 'Ich möchte mein Paket zurückschicken und mich über die Erstattungsbedingungen informieren.'
    }, {
      url: "".concat(FAQ_URL['de-AT'], "/articles/2544773-colissimo-dpd-welche-fristen-und-bedingungen-gelten-fur-die-lieferung"),
      label: 'Colissimo: welche Fristen und Bedingungen gelten für die Lieferung?'
    }],
    GIFTS: [{
      url: 'https://app.intercom.io/a/apps/sb9q4ncy/articles/articles/2544426/show',
      label: 'Wie kann ich meinen Gutschein einlösen?'
    }, {
      url: "".concat(FAQ_URL['de-AT'], "/articles/2544386-wie-kann-ich-meine-geschenkkarte-einlosen"),
      label: 'Wie kann ich meine Geschenkkarte einlösen?'
    }],
    PROFILE: [{
      url: "".concat(FAQ_URL['de-AT'], "/articles/2544332-wie-kann-ich-meine-rechte-bezuglich-des-schutzes-meiner-personenbezogenen-daten-ausuben"),
      label: 'Wie kann ich meine Rechte bezüglich des Schutzes meiner personenbezogenen Daten ausüben?'
    }, {
      url: "".concat(FAQ_URL['de-AT'], "/articles/2544346-ich-habe-mein-passwort-vergessen-was-kann-ich-tun"),
      label: 'Ich habe mein Passwort vergessen, was kann ich tun?'
    }],
    SHIPPINGDETAILS: [{
      url: "".concat(FAQ_URL['de-AT'], "/de/collections/1471417-lieferung")
    }],
    OTHERQUESTION: [{
      url: "".concat(FAQ_URL['de-AT'], "/de/collections/1471417-lieferung")
    }],
    EXCHANGEPRODUCT: [{
      url: "".concat(FAQ_URL['de-AT'], "/de/collections/1471417-lieferung")
    }]
  }
}, {
  language: 'it-CH',
  questions: {
    HOTTOPICS: [{
      url: "".concat(FAQ_URL['it-CH'], "/it/collections/1460829-consegna"),
      label: 'Consegna'
    }, {
      url: "".concat(FAQ_URL['it-CH'], "/it/collections/1460838-resi-e-rimborsi"),
      label: 'Resi e rimborsi'
    }, {
      url: "".concat(FAQ_URL['it-CH'], "/it/collections/1410546-prodotti-e-disponibilita"),
      label: 'Prodotti e disponibilità'
    }],
    HOME: [{
      url: "".concat(FAQ_URL['it-CH'], "/articles/2527718-quali-sono-i-costi-di-spedizione"),
      label: 'Quali sono i costi di spedizione'
    }, {
      url: "".concat(FAQ_URL['it-CH'], "/articles/2527836-quale-corriere-consegnera-il-mio-ordine"),
      label: 'Quale corriere consegnerà il moi ordine'
    }],
    ORDERS: [{
      url: "".concat(FAQ_URL['it-CH'], "/articles/2527145-come-posso-seguire-il-mio-ordine"),
      label: 'Come posso seguire il mio ordine?'
    }, {
      url: "".concat(FAQ_URL['it-CH'], "/articles/2529606-quali-sono-i-tempi-e-le-modalita-di-rimborso"),
      label: 'Quali sono i tempi e le modalità di rimborso?'
    }],
    ORDERDETAILS: [{
      url: "".concat(FAQ_URL['it-IT'], "/it/articles/2523740-chronopost-quali-sono-i-tempi-e-le-modalita-di-consegna"),
      label: 'Chronopost: quali sono i tempi e le modalità di consegna?'
    }, {
      url: "".concat(FAQ_URL['it-IT'], "/it/articles/2480020-geodis-bartolini-quali-sono-i-tempi-e-le-modalita-di-consegna"),
      label: 'Geodis MLP : quali sono i tempi e le modalità di consegna?'
    }],
    GIFTS: [{
      url: "".concat(FAQ_URL['it-CH'], "/articles/2526929-c-e-una-carta-fedelta-maisons-du-monde"),
      label: "C'è una carta di fedeltà Maisons du Monde?"
    }, {
      url: "".concat(FAQ_URL['it-CH'], "/articles/2526470-come-uso-il-mio-buono-acquisto"),
      label: 'Come uso il moi buono acquisto '
    }],
    PROFILE: [{
      url: "".concat(FAQ_URL['it-CH'], "/articles/2526926-come-posso-esercitare-i-miei-diritti-nella-protezione-dei-miei-dati-personali"),
      label: 'Come posso esercitare i miei diritti nella protezione dei miei dati personali?'
    }, {
      url: "".concat(FAQ_URL['it-CH'], "/articles/2527138-non-ho-ricevuto-l-email-di-conferma-o-di-spedizione-dell-ordine"),
      label: "Non ho ricevuto l'email di conferma o di spedizione dell'ordine"
    }],
    SHIPPINGDETAILS: [{
      url: "".concat(FAQ_URL['it-CH'], "/it/collections/1460829-consegna")
    }],
    OTHERQUESTION: [{
      url: "".concat(FAQ_URL['it-CH'], "/it/collections/1460829-consegna")
    }],
    EXCHANGEPRODUCT: [{
      url: "".concat(FAQ_URL['it-CH'], "/it/collections/1460829-consegna")
    }]
  }
}, {
  language: 'fr-CH',
  questions: {
    HOTTOPICS: [{
      url: "".concat(FAQ_URL['fr-CH'], "/fr/collections/1413246-livraison"),
      label: 'Livraison'
    }, {
      url: "".concat(FAQ_URL['fr-CH'], "/fr/collections/1413252-retour-et-remboursement"),
      label: 'Retour et remboursement'
    }, {
      url: "".concat(FAQ_URL['fr-CH'], "/fr/collections/1410548-produits-et-disponibilite"),
      label: 'Produit et disponibilité'
    }],
    HOME: [{
      url: "".concat(FAQ_URL['fr-CH'], "/articles/2446688-quel-est-le-montant-des-frais-de-livraison"),
      label: 'Quel est le montant des frais de livraison ?'
    }, {
      url: "".concat(FAQ_URL['fr-CH'], "/articles/2446711-quel-transporteur-va-me-livrer"),
      label: 'Quel transporteur va me livrer ?'
    }],
    ORDERS: [{
      url: "".concat(FAQ_URL['fr-CH'], "/articles/2446788-quels-sont-les-delais-et-modes-de-remboursement"),
      label: 'Quels sont les délais et modes de remboursement ?'
    }, {
      url: "".concat(FAQ_URL['fr-CH'], "/articles/2446615-est-il-possible-de-me-faire-livrer-en-magasin"),
      label: 'Est-il possible de me faire livrer en magasin?'
    }],
    ORDERDETAILS: [{
      url: "".concat(FAQ_URL['fr-CH'], "/articles/2541099-chronopost-dpd-quels-sont-les-delais-et-modalites-d-une-livraison"),
      label: "Chronopost / DPD : quels sont les délais et modalités d'une livraison ?"
    }, {
      url: "".concat(FAQ_URL['fr-CH'], "/articles/2446694-geodis-mlp-quels-sont-les-delais-et-modalites-d-une-livraison"),
      label: "Geodis MLP : quels sont les délais et modalités d'une livraison ?"
    }],
    GIFTS: [{
      url: "".concat(FAQ_URL['fr-CH'], "/articles/2446560-je-souhaite-offrir-une-carte-cadeau"),
      label: 'Je souhaite offrir une carte cadeau.'
    }, {
      url: "".concat(FAQ_URL['fr-CH'], "/articles/2446306-comment-consulter-le-solde-de-mon-avoir"),
      label: 'Comment consulter le solde de mon avoir ?'
    }],
    PROFILE: [{
      url: "".concat(FAQ_URL['fr-CH'], "/articles/2446155-comment-puis-je-exercer-mes-droits-en-matiere-de-protection-de-mes-donnees-personnelles"),
      label: 'Comment puis-je exercer mes droits en matière de protection de mes données personnelles ?'
    }, {
      url: "".concat(FAQ_URL['fr-CH'], "/articles/2440463-je-n-ai-pas-recu-mon-e-mail-de-confirmation-ou-d-expedition-de-commande"),
      label: "Je n'ai pas reçu mon e-mail de confirmation ou d'expédition de commande."
    }],
    SHIPPINGDETAILS: [{
      url: "".concat(FAQ_URL['fr-CH'], "/fr/collections/1413246-livraison")
    }],
    OTHERQUESTION: [{
      url: "".concat(FAQ_URL['fr-CH'], "/fr/collections/1413246-livraison")
    }],
    EXCHANGEPRODUCT: [{
      url: "".concat(FAQ_URL['fr-CH'], "/fr/collections/1413246-livraison")
    }]
  }
}, {
  language: 'de-CH',
  questions: {
    HOTTOPICS: [{
      url: "".concat(FAQ_URL['de-CH'], "/de/collections/1466189-lieferung"),
      label: 'Lieferung'
    }, {
      url: "".concat(FAQ_URL['de-CH'], "/de/collections/1466199-retouren-und-erstattungen"),
      label: 'Retouren und Erstattungen'
    }, {
      url: "".concat(FAQ_URL['de-CH'], "/de/collections/1410543-artikel-und-verfugbarkeit"),
      label: 'Artikel und Verfügbarkeit'
    }],
    HOME: [{
      url: "".concat(FAQ_URL['de-CH'], "/articles/2536581-wie-hoch-sind-die-lieferkosten"),
      label: 'Wie hoch sind die Lieferkosten?'
    }, {
      url: "".concat(FAQ_URL['de-CH'], "/articles/2536652-welcher-spediteur-wird-mich-beliefern"),
      label: 'Welcher Spediteur wird mich beliefern?'
    }],
    ORDERS: [{
      url: "".concat(FAQ_URL['de-CH'], "/articles/2540962-welche-fristen-und-bedingungen-gelten-fur-die-erstattung"),
      label: 'Welche Fristen und Bedingungen gelten für die Erstattung?'
    }, {
      url: "".concat(FAQ_URL['de-CH'], "/articles/2536840-werden-meine-lieferkosten-erstattet"),
      label: 'Werden meine Lieferkosten erstattet?'
    }],
    ORDERDETAILS: [{
      url: "".concat(FAQ_URL['de-CH'], "/articles/2536628-geodis-mlp-welche-fristen-und-bedingungen-gelten-fur-die-lieferung"),
      label: 'Geodis MLP: welche Fristen und Bedingungen gelten für die Lieferung?'
    }, {
      url: "".concat(FAQ_URL['de-CH'], "/articles/2540961-kann-ich-ein-im-internet-bestelltes-mobel-in-einer-filiale-umtauschen"),
      label: 'Kann ich im Internet bestellte Möbel in einer Filiale umtauschen?'
    }],
    GIFTS: [{
      url: "".concat(FAQ_URL['de-CH'], "/articles/2540758-wie-kann-ich-meinen-gutschein-einlosen"),
      label: 'Wie kann ich meinen Gutschein einlösen?'
    }, {
      url: "".concat(FAQ_URL['de-CH'], "/articles/2540761-wie-kann-ich-meine-geschenkkarte-einlosen"),
      label: 'Wie kann ich meine Geschenkkarte einlösen?'
    }],
    PROFILE: [{
      url: "".concat(FAQ_URL['de-CH'], "/articles/2536368-wie-kann-ich-meine-rechte-bezuglich-des-schutzes-meiner-personenbezogenen-daten-ausuben"),
      label: 'Wie kann ich meine Rechte bezüglich des Schutzes meiner personenbezogenen Daten ausüben?'
    }, {
      url: "".concat(FAQ_URL['de-CH'], "/articles/2536381-ich-habe-mein-passwort-vergessen-was-kann-ich-tun"),
      label: 'Ich habe mein Passwort vergessen, was kann ich tun?'
    }],
    SHIPPINGDETAILS: [{
      url: "".concat(FAQ_URL['de-CH'], "/de/collections/1466189-lieferung")
    }],
    OTHERQUESTION: [{
      url: "".concat(FAQ_URL['de-CH'], "/de/collections/1466189-lieferung")
    }],
    EXCHANGEPRODUCT: [{
      url: "".concat(FAQ_URL['de-CH'], "/de/collections/1466189-lieferung")
    }]
  }
}, {
  language: 'es-ES',
  questions: {
    HOTTOPICS: [{
      url: "".concat(FAQ_URL['es-ES'], "/es/collections/1440575-envio"),
      label: 'Envío'
    }, {
      url: "".concat(FAQ_URL['es-ES'], "/es/collections/1440576-devolucion-y-reembolso"),
      label: 'Devolución y reembolso'
    }, {
      url: "".concat(FAQ_URL['es-ES'], "/es/collections/1410550-productos-y-disponibilidad"),
      label: 'Productos y disponibilidad'
    }],
    HOME: [{
      url: "".concat(FAQ_URL['es-ES'], "/articles/2495375-cual-es-el-importe-de-los-gastos-de-envio"),
      label: '¿Cuál es el importe de los gastos de envío?'
    }, {
      url: "".concat(FAQ_URL['es-ES'], "/articles/2495618-que-transportista-realizara-mi-entrega"),
      label: '¿Qué transportista realizará mi entrega?'
    }, {
      url: "".concat(FAQ_URL['es-ES'], "/es/articles/5879970-como-ponerse-en-contacto-con-el-vendedor-marketplace"),
      label: '¿Cómo contactar con mi vendedor de Marketplace?'
    }],
    ORDERS: [{
      url: "".concat(FAQ_URL['es-ES'], "/articles/2498188-cuales-son-los-plazos-y-modos-de-reembolso"),
      label: '¿Cuáles son los plazos y modos de reembolso?'
    }, {
      url: "".concat(FAQ_URL['es-ES'], "/articles/2496177-me-reembolsareis-los-gastos-de-envio"),
      label: '¿Me reembolsaréis los gastos de envío?'
    }],
    ORDERDETAILS: [{
      url: "".concat(FAQ_URL['es-ES'], "/articles/2495595-ab-custom-cuales-son-los-plazos-y-modalidades-de-entrega"),
      label: 'Ab Custom: ¿cuáles son los plazos y modalidades de entrega?'
    }, {
      url: "".concat(FAQ_URL['es-ES'], "/articles/2881170-puedo-devolver-un-articulo-pedido-desde-la-pagina-web-en-tienda"),
      label: '¿Puedo devolver un artículo pedido desde la página web en tienda?'
    }],
    GIFTS: [{
      url: "".concat(FAQ_URL['es-ES'], "/articles/2494662-existe-una-tarjeta-de-fidelidad-maisons-du-monde"),
      label: '¿Existe una tarjeta de fidelidad Maisons du Monde?'
    }, {
      url: "".concat(FAQ_URL['es-ES'], "/articles/2495645-he-comprado-una-tarjeta-regalo-por-internet-y-necesito-una-factura"),
      label: 'He comprado una tarjeta regalo por internet y necesito una factura.'
    }],
    PROFILE: [{
      url: "".concat(FAQ_URL['es-ES'], "/articles/2492541-como-puedo-ejercer-mis-derechos-en-materia-de-proteccion-de-mis-datos-personales"),
      label: '¿Cómo puedo ejercer mis derechos en materia de protección de mis datos personales?'
    }, {
      url: "".concat(FAQ_URL['es-ES'], "/articles/2494787-deseo-modificar-mi-direccion-de-facturacion"),
      label: 'Deseo modificar mi dirección de factura'
    }],
    SHIPPINGDETAILS: [{
      url: "".concat(FAQ_URL['es-ES'], "/es/collections/1440575-envio")
    }],
    OTHERQUESTION: [{
      url: "".concat(FAQ_URL['es-ES'], "/es/collections/1440575-envio")
    }],
    EXCHANGEPRODUCT: [{
      url: "".concat(FAQ_URL['es-ES'], "/es/collections/1440575-envio")
    }]
  }
}, {
  language: 'it-IT',
  questions: {
    HOTTOPICS: [{
      url: "".concat(FAQ_URL['it-IT'], "/it/collections/1432865-consegna"),
      label: 'Consegna'
    }, {
      url: "".concat(FAQ_URL['it-IT'], "/it/collections/1433177-resi-e-rimborsi"),
      label: 'Resi e rimborsi'
    }, {
      url: "".concat(FAQ_URL['it-IT'], "/it/collections/1432899-prodotti-e-disponibilita"),
      label: 'Prodotti e disponibilità'
    }],
    HOME: [{
      url: "".concat(FAQ_URL['it-IT'], "/articles/2479818-quali-sono-i-costi-di-spedizione"),
      label: 'Quali sono i costi di spedizione?'
    }, {
      url: "".concat(FAQ_URL['it-IT'], "/articles/2479719-quale-corriere-consegnera-il-mio-ordine"),
      label: 'Quale corriere consegnerà il moi ordine '
    }, {
      url: "".concat(FAQ_URL['it-IT'], "/it/collections/3511834-marketplace"),
      label: 'Come contattare il rivenditore Marketplace?'
    }],
    ORDERS: [{
      url: "".concat(FAQ_URL['it-IT'], "/articles/2480595-quali-sono-i-tempi-e-le-modalita-di-rimborso"),
      label: 'Quali sono i tempi e le modalità di rimborso?'
    }, {
      url: "".concat(FAQ_URL['it-IT'], "/articles/2480587-posso-sostituire-in-negozio-un-mobile-ordinato-su-internet"),
      label: 'Posso sostituire in negozio un mobile ordinato su Internet?'
    }, {
      url: "".concat(FAQ_URL['it-IT'], "/it/collections/3511834-marketplace"),
      label: 'Come contattare il rivenditore Marketplace?'
    }],
    ORDERDETAILS: [{
      url: "".concat(FAQ_URL['it-IT'], "/articles/2480049-colissimo-quali-sono-i-tempi-e-le-modalita-di-consegna"),
      label: 'Colissimo: quali sono i tempi e le modalità di consegna?'
    }, {
      url: "".concat(FAQ_URL['it-IT'], "/articles/2480063-dhl-quali-sono-i-tempi-e-le-modalita-di-consegna"),
      label: 'DHL: quali sono i tempi e le modalità di consegna?'
    }],
    GIFTS: [{
      url: "".concat(FAQ_URL['it-IT'], "/articles/2479705-vorrei-offrire-una-carta-regalo"),
      label: 'Vorrei offrire una carta regalo.'
    }, {
      url: "".concat(FAQ_URL['it-IT'], "/articles/2479682-c-e-una-carta-fedelta-maisons-du-monde"),
      label: "C'è una carta fedeltà Maisons du Monde?"
    }],
    PROFILE: [{
      url: "".concat(FAQ_URL['it-IT'], "/articles/2479779-come-posso-esercitare-i-miei-diritti-nella-protezione-dei-miei-dati-personali"),
      label: 'Come posso esercitare i miei diritti nella protezione dei miei dati personali?'
    }, {
      url: "".concat(FAQ_URL['it-IT'], "/articles/2479807-voglio-cambiare-il-mio-indirizzo-di-consegna"),
      label: 'Voglio cambiare il mio indirizzo di consegna '
    }],
    SHIPPINGDETAILS: [{
      url: "".concat(FAQ_URL['it-IT'], "/it/collections/1432865-consegna")
    }],
    OTHERQUESTION: [{
      url: "".concat(FAQ_URL['it-IT'], "/it/collections/1432865-consegna")
    }],
    EXCHANGEPRODUCT: [{
      url: "".concat(FAQ_URL['it-IT'], "/it/collections/1432865-consegna")
    }]
  }
}, {
  language: 'pt-PT',
  questions: {
    HOTTOPICS: [{
      url: "".concat(FAQ_URL['pt-PT'], "/pt/collections/1472882-envio"),
      label: 'Envio'
    }, {
      url: "".concat(FAQ_URL['pt-PT'], "/pt/collections/1472887-devolucao-e-reembolso"),
      label: 'Devolução e reembolso'
    }, {
      url: "".concat(FAQ_URL['pt-PT'], "/pt/collections/1410568-produtos-e-disponibilidade"),
      label: 'Produtos e disponibilidade'
    }],
    HOME: [{
      url: "".concat(FAQ_URL['pt-PT'], "/articles/2547530-how-much-is-the-cost-of-delivery"),
      label: 'How much is the cost of delivery?'
    }, {
      url: "".concat(FAQ_URL['pt-PT'], "/articles/2547533-what-is-maison-du-monde-s-delivery-area"),
      label: "What is Maisons du Monde's delivery area?"
    }],
    ORDERS: [{
      url: "".concat(FAQ_URL['pt-PT'], "/articles/2547549-what-courier-do-you-use-for-delivery"),
      label: 'What courier do you use for delivery?'
    }, {
      url: "".concat(FAQ_URL['pt-PT'], "/articles/2547866-what-is-the-procedure-for-a-refund-and-how-long-does-it-take"),
      label: 'What is the procedure for a refund and how long does it take?'
    }],
    ORDERDETAILS: [{
      url: "".concat(FAQ_URL['pt-PT'], "/articles/2547544-chronopost-what-are-the-delivery-times-and-procedures"),
      label: 'Chronopost: what are the delivery times and procedures?'
    }, {
      url: "".concat(FAQ_URL['pt-PT'], "/articles/2547541-colissimo-what-are-the-delivery-times-and-procedures"),
      label: 'Colissimo: what are the delivery times and procedures?'
    }],
    GIFTS: [{
      url: "".concat(FAQ_URL['pt-PT'], "/articles/2547623-how-do-i-use-my-voucher"),
      label: 'How do I use my voucher?'
    }, {
      url: "".concat(FAQ_URL['pt-PT'], "/articles/2553876-how-do-i-use-my-gift-card"),
      label: 'How do I use my gift card?'
    }],
    PROFILE: [{
      url: "".concat(FAQ_URL['pt-PT'], "/articles/2547463-i-would-like-to-change-my-delivery-address"),
      label: 'I would like to change my delivery address'
    }, {
      url: "".concat(FAQ_URL['pt-PT'], "/articles/2547214-how-do-i-exercise-my-rights-in-relation-to-my-personal-data"),
      label: 'How do I excercise my rights in relation to my personnal data?'
    }],
    SHIPPINGDETAILS: [{
      url: "".concat(FAQ_URL['pt-PT'], "/pt/collections/1472882-envio")
    }],
    OTHERQUESTION: [{
      url: "".concat(FAQ_URL['pt-PT'], "/pt/collections/1472882-envio")
    }],
    EXCHANGEPRODUCT: [{
      url: "".concat(FAQ_URL['pt-PT'], "/pt/collections/1472882-envio")
    }]
  }
}];
var MODULE_FAQ_V2 = [{
  title: 'frequently-asked-questions-01',
  questions: [{
    language: 'fr-FR',
    label: 'Quel transporteur va me livrer ?',
    url: "".concat(FAQ_URL['fr-FR'], "/fr/articles/2370783-quel-transporteur-va-me-livrer")
  }, {
    language: 'fr-BE',
    label: 'Quels sont les délais et modalités d’une livraison en magasin ?',
    url: "".concat(FAQ_URL['fr-BE'], "/fr/articles/2443602-quels-sont-les-delais-et-modalites-d-une-livraison-en-magasin")
  }, {
    language: 'fr-LU',
    label: 'Quels sont les délais et modalités d’une livraison en magasin ?',
    url: "".concat(FAQ_URL['fr-LU'], "/fr/articles/2550950-quels-sont-les-delais-et-modalites-d-une-livraison-en-magasin")
  }, {
    language: 'fr-CH',
    label: 'Quels sont les délais et modalités d’une livraison en magasin ?',
    url: "".concat(FAQ_URL['fr-CH'], "/fr/articles/2446692-quels-sont-les-delais-et-modalites-d-une-livraison-en-magasin")
  }, {
    language: 'it-IT',
    label: 'Quali sono i costi di spedizione?',
    url: "".concat(FAQ_URL['it-IT'], "/articles/2479818-quali-sono-i-costi-di-spedizione")
  }, {
    language: 'it-CH',
    label: 'Quali sono i costi di spedizione?',
    url: "".concat(FAQ_URL['it-CH'], "/it/articles/2527718-quali-sono-i-costi-di-spedizione")
  }, {
    language: 'es-ES',
    label: '¿Cuáles son los plazos y modos de reembolso?',
    url: "".concat(FAQ_URL['es-ES'], "/articles/2498188-cuales-son-los-plazos-y-modos-de-reembolso")
  }, {
    language: 'de-DE',
    label: 'Welche Fristen und Bedingungen gelten für die Erstattung?',
    url: "".concat(FAQ_URL['de-DE'], "/articles/2530996-welche-fristen-und-bedingungen-gelten-fur-die-erstattung")
  }, {
    language: 'de-CH',
    label: 'Welche Fristen und Bedingungen gelten für die Erstattung?',
    url: "".concat(FAQ_URL['de-CH'], "/de/articles/4231145-welche-fristen-und-bedingungen-gelten-fur-die-erstattung")
  }, {
    language: 'de-AT',
    label: 'Welche Fristen und Bedingungen gelten für die Erstattung?',
    url: "".concat(FAQ_URL['de-AT'], "/de/articles/2546837-welche-fristen-und-bedingungen-gelten-fur-die-erstattung")
  }, {
    language: 'en-GB',
    label: 'I want to return a product that I ordered online?',
    url: "".concat(FAQ_URL['en-GB'], "/en/articles/2283861-i-want-to-return-a-product-that-i-ordered-online")
  }, {
    language: 'pt-PT',
    label: 'Qual é o valor dos portes de envio?',
    url: "".concat(FAQ_URL['pt-PT'], "/pt/articles/2547530-qual-e-o-valor-dos-portes-de-envio")
  }, {
    language: 'nl-NL',
    label: 'Hoeveel bedragen de verzendkosten?',
    url: "".concat(FAQ_URL['nl-NL'], "/articles/2543838-hoeveel-bedragen-de-verzendkosten")
  }, {
    language: 'nl-BE',
    label: 'Hoeveel bedragen de verzendkosten?',
    url: "".concat(FAQ_URL['nl-BE'], "/nl/articles/2535808-hoeveel-bedragen-de-verzendkosten")
  }]
}, {
  title: 'frequently-asked-questions-02',
  questions: [{
    language: 'fr-FR',
    label: 'Puis-je retourner en magasin un article commandé sur internet ?',
    url: "".concat(FAQ_URL['fr-FR'], "/fr/articles/2824941-puis-je-retourner-en-magasin-un-article-commande-sur-internet")
  }, {
    language: 'fr-BE',
    label: 'Quels sont les délais et modes de remboursement ?',
    url: "".concat(FAQ_URL['fr-BE'], "/fr/articles/2443786-quels-sont-les-delais-et-modes-de-remboursement")
  }, {
    language: 'fr-LU',
    label: 'Quels sont les délais et modes de remboursement ?',
    url: "".concat(FAQ_URL['fr-LU'], "/fr/articles/2551352-quels-sont-les-delais-et-modes-de-remboursement")
  }, {
    language: 'fr-CH',
    label: 'Quels sont les délais et modes de remboursement ?',
    url: "".concat(FAQ_URL['fr-CH'], "/fr/articles/2446788-quels-sont-les-delais-et-modes-de-remboursement")
  }, {
    language: 'it-IT',
    label: 'Quale corriere consegnera il mio ordine?',
    url: "".concat(FAQ_URL['it-IT'], "/articles/2479719-quale-corriere-consegnera-il-mio-ordine")
  }, {
    language: 'it-CH',
    label: 'Quale corriere consegnera il mio ordine?',
    url: "".concat(FAQ_URL['it-CH'], "/it/articles/2527836-quale-corriere-consegnera-il-mio-ordine")
  }, {
    language: 'es-ES',
    label: '¿Cuál es el importe de los gastos de envío?',
    url: "".concat(FAQ_URL['es-ES'], "/articles/2495375-cual-es-el-importe-de-los-gastos-de-envio")
  }, {
    language: 'de-DE',
    label: 'Wie hoch sind die Lieferkosten?',
    url: "".concat(FAQ_URL['de-DE'], "/articles/2532705-wie-hoch-sind-die-lieferkosten")
  }, {
    language: 'de-CH',
    label: 'Wie hoch sind die Lieferkosten?',
    url: "".concat(FAQ_URL['de-CH'], "/de/articles/4231153-wie-hoch-sind-die-lieferkosten")
  }, {
    language: 'de-AT',
    label: 'Wie hoch sind die Lieferkosten?',
    url: "".concat(FAQ_URL['de-AT'], "/de/articles/4231253-wie-hoch-sind-die-lieferkosten")
  }, {
    language: 'en-GB',
    label: 'What are the delivery costs?',
    url: "".concat(FAQ_URL['en-GB'], "/articles/2281868-what-are-the-delivery-costs")
  }, {
    language: 'pt-PT',
    label: 'Onde entrega a Maisons du Monde?',
    url: "".concat(FAQ_URL['pt-PT'], "/pt/articles/2547533-onde-entrega-a-maisons-du-monde")
  }, {
    language: 'nl-NL',
    label: 'Welke transporteur zal mijn bestelling leveren?',
    url: "".concat(FAQ_URL['nl-NL'], "/articles/2543877-welke-transporteur-zal-mijn-bestelling-leveren")
  }, {
    language: 'nl-BE',
    label: 'Welke transporteur zal mijn bestelling leveren?',
    url: "".concat(FAQ_URL['nl-BE'], "/nl/articles/2535851-welke-transporteur-zal-mijn-bestelling-leveren")
  }]
}, {
  title: 'frequently-asked-questions-03',
  questions: [{
    // a rollback après confinement
    language: 'fr-FR',
    label: "Quel est le montant des frais de livraison d'une commande d'articles Maisons du Monde ?",
    url: "".concat(FAQ_URL['fr-FR'], "/fr/articles/2158893-quel-est-le-montant-des-frais-de-livraison-d-une-commande-d-articles-maisons-du-monde")
  }, {
    language: 'fr-BE',
    label: 'Puis-je retourner en magasin un article commandé sur internet ?',
    url: "".concat(FAQ_URL['fr-BE'], "/fr/articles/2875389-puis-je-retourner-en-magasin-un-article-commande-sur-internet")
  }, {
    language: 'fr-LU',
    label: 'Puis-je retourner en magasin un article commandé sur internet ?',
    url: "".concat(FAQ_URL['fr-LU'], "/fr/articles/2875395-puis-je-retourner-en-magasin-un-article-commande-sur-internet")
  }, {
    language: 'fr-CH',
    label: 'Puis-je retourner en magasin un article commandé sur internet ?',
    url: "".concat(FAQ_URL['fr-CH'], "/fr/articles/2875394-puis-je-retourner-en-magasin-un-article-commande-sur-internet")
  }, {
    language: 'it-IT',
    label: 'Quali sono i tempi e le modalita di rimborso?',
    url: "".concat(FAQ_URL['it-IT'], "/it/articles/2480595-quali-sono-i-tempi-e-le-modalita-di-rimborso")
  }, {
    language: 'it-CH',
    label: 'Quali sono i tempi e le modalita di rimborso?',
    url: "".concat(FAQ_URL['it-CH'], "/it/articles/4230872-quali-sono-i-tempi-e-le-modalita-di-rimborso")
  }, {
    language: 'es-ES',
    label: '¿Puedo devolver un artículo pedido desde la página web en tienda?',
    url: "".concat(FAQ_URL['es-ES'], "/es/articles/2881170-puedo-devolver-un-articulo-pedido-desde-la-pagina-web-en-tienda")
  }, {
    language: 'de-DE',
    label: 'Welcher Spediteur wird mich beliefern?',
    url: "".concat(FAQ_URL['de-DE'], "/articles/2532781-welcher-spediteur-wird-mich-beliefern")
  }, {
    language: 'de-CH',
    label: 'Welcher Spediteur wird mich beliefern?',
    url: "".concat(FAQ_URL['de-CH'], "/de/articles/2536652-welcher-spediteur-wird-mich-beliefern")
  }, {
    language: 'de-AT',
    label: 'Welcher Spediteur wird mich beliefern?',
    url: "".concat(FAQ_URL['de-AT'], "/de/articles/4231270-welcher-spediteur-wird-mich-beliefern")
  }, {
    language: 'en-GB',
    label: 'What are the delivery regions for Maisons du Monde?',
    url: "".concat(FAQ_URL['en-GB'], "/en/articles/2281872-what-are-the-delivery-regions-for-maisons-du-monde")
  }, {
    language: 'pt-PT',
    label: 'Que empresa de transporte se encarregará da minha entrega?',
    url: "".concat(FAQ_URL['pt-PT'], "/pt/articles/2547549-que-empresa-de-transporte-se-encarregara-da-minha-entrega")
  }, {
    language: 'nl-NL',
    label: 'Ik wil mijn pakket retourneren en de terugbetalingsvoorwaarden kennen.',
    url: "".concat(FAQ_URL['nl-NL'], "/nl/articles/2543999-ik-wil-mijn-pakket-retourneren-en-de-terugbetalingsvoorwaarden-kennen")
  }, {
    language: 'nl-BE',
    label: 'Ik wil mijn pakket retourneren en de terugbetalingsvoorwaarden kennen.',
    url: "".concat(FAQ_URL['nl-BE'], "/nl/articles/2535964-heeft-u-online-een-bestelling-geplaatst-en-werd-deze-bij-u-thuis-of-in-een-afhaalpunt-afgeleverd")
  }]
}];
export var getQuestionsByLanguage = function getQuestionsByLanguage(id, lang) {
  return MODULE_FAQ_V2.find(function (e) {
    return e.title === id;
  }).questions.find(function (l) {
    return l.language === lang;
  });
};
export var LEGAL_NOTICE = [{
  language: 'fr-FR',
  text: "MAISONS DU MONDE FRANCE traite vos données personnelles pour répondre à votre demande. Conformément au Règlement(UE) 2016 / 679 du parlement Européen et du Conseil du 27 avril 2016, vous disposez d'un droit d'accès, de rectification, d'effacement et d'opposition de vos données personnelles ainsi qu'un droit à la limitation et à la portabilité de vos données.<a href=\"https://faq-france.maisonsdumonde.com/mon-compte-et-informations-personnelles/comment-puis-je-exercer-mes-droits-en-matiere-de-protection-de-mes-donnees-personnelles\">Vous pouvez exercer vos droits en cliquant sur ce lien.</a> <a href=\"https://www.maisonsdumonde.com/FR/fr/e/legal/securite-et-confidentialite\">Concernant notre politique de protection des données personnelles vous la trouverez en cliquant sur ce lien.</a>",
  url: '/FR/fr/e/legal/credits-et-mentions-legales'
}, {
  language: 'es-ES',
  text: 'MAISONS DU MONDE ESPAÑA SL trata sus datos personales para responder a su solicitud. De Conformidad con el Reglamento(UE) 2016 / 679 del Parlamento Europeo y del Consejo del 27 de abril de 2016 usted dispone de un derecho de acceso, rectificación, limitación u oposición al tratamiento y supresión de sus datos personales, <a href="https://faq-es.maisonsdumonde.com/mi-cuenta-y-datos-personales/como-puedo-ejercer-mis-derechos-en-materia-de-proteccion-de-mis-datos-personales">así como de portabilidad de los mismos, haciendo clic en este enlace.</a> <a href="https://www.maisonsdumonde.com/ES/es/statique/securite-et-confidentialite.htm">Para conocer nuestra Política de Privacidad, visite la sección “Datos Personales” en nuestra página web haciendo clic en este enlace.</a>',
  url: '/ES/es/e/legal/creditos-y-menciones-legales'
}, {
  language: 'it-IT',
  text: 'MAISONS DU MONDE ITALIE S.P.A tratta i suoi dati personali per rispondere alla sua richiesta. Conformemente al Regolamento(UE) 2016 / 679 del Parlamento europeo e del Consiglio del 27 aprile 2016, l\'utente dispone di un diritto di accesso, rettifica, limitazione e cancellazione dei propri dati personali. <a href="https://www.maisonsdumonde.com/IT/it/statique/securite-et-confidentialite.htm">Puoi consultare qui la nostra informativa sulla privacy.</a> <a href="https://faq-italia.maisonsdumonde.com/il-mio-account-e-informazioni-personali/come-posso-esercitare-i-miei-diritti-nella-protezione-dei-miei-dati-personali">Per ulteriori informazioni sui tuoi dati personali, non esitare a contattarci cliccando su questo link.</a>',
  url: '/IT/it/e/legal/crediti-e-menzioni-legali'
}, {
  language: 'de-DE',
  text: 'MAISONS DU MONDE ALLEMAGNE GmbH nutzt Ihre personenbezogenen Daten gem. Art. 6 Absatz 1 lit. b), c), f) Datenschutzgrundverordnung (DSGVO), um auf Ihre Anfrage zu antworten. Sie können bezüglich Ihrer bei uns verarbeiteten Daten gem. Art. 15-18, 20, 21 DSGVO jederzeit Auskunft, Berichtigung, Löschung, Beschränkung der Verarbeitung und Übertragung der Daten verlangen und der weiteren Verarbeitung jederzeit widersprechen. <a href="https://faq-deutschland.maisonsdumonde.com/mein-konto-und-personliche-daten/wie-kann-ich-meine-rechte-bezuglich-des-schutzes-meiner-personenbezogenen-daten-ausuben">Für alle Anträge zur Geltendmachung Ihrer vorbezeichneten Rechte klicken Sie bitte hier.</a> <a href="https://www.maisonsdumonde.com/DE/de/statique/securite-et-confidentialite.htm">Weitere Informationen zur Verarbeitung Ihrer Daten finden Sie unter</a>',
  url: '/DE/de/e/legal/bildnachweise-und-impressum'
}, {
  language: 'fr-BE',
  text: "MAISONS DU MONDE BELGIQUE SPRL traite vos données personnelles pour répondre à votre demande. Conformément au Règlement(UE) 2016 / 679 du parlement Européen et du Conseil du 27 avril 2016, vous disposez d'un droit d'accès, de rectification, d'effacement et d'opposition de vos données personnelles ainsi qu'un droit à la limitation et à la portabilité de vos données.<a href=\"https://faq-belgique.maisonsdumonde.com/mon-compte-et-informations-personnelles/comment-puis-je-exercer-mes-droits-en-matiere-de-protection-de-mes-donnees-personnelles\">Vous pouvez exercer vos droits en cliquant sur ce lien.</a> <a href=\"https://www.maisonsdumonde.com/BE/fr/statique/securite-et-confidentialite.htm\">Concernant notre politique de protection des données personnelles vous la trouverez en cliquant sur ce lien.</a>",
  url: '/BE/fr/e/legal/credits-et-mentions-legales'
}, {
  language: 'de-AT',
  text: 'MAISONS DU MONDE ÖSTERREICH nutzt Ihre personenbezogenen Daten gem. Art. 6 Absatz 1 lit. b), c), f) Datenschutzgrundverordnung (DSGVO), um auf Ihre Anfrage zu antworten. Sie können bezüglich Ihrer bei uns verarbeiteten Daten gem. Art. 15-18, 20, 21 DSGVO jederzeit Auskunft, Berichtigung, Löschung, Beschränkung der Verarbeitung und Übertragung der Daten verlangen und der weiteren Verarbeitung jederzeit widersprechen. <a href="https://www.maisonsdumonde.com/AT/de/compte2/?action=aide&rub=RD_INFOPERS">Für alle Anträge zur Geltendmachung Ihrer vorbezeichneten Rechte klicken Sie bitte hier.</a> <a href="https://www.maisonsdumonde.com/AT/de/statique/securite-et-confidentialite.htm">Weitere Informationen zur Verarbeitung Ihrer Daten finden Sie unter.</a>',
  url: '/AT/de/e/legal/bildnachweise-und-impressum'
}, {
  language: 'nl-BE',
  text: 'MAISONS DU MONDE BELGIQUE SPRL verwerkt uw persoonsgegevens om uw verzoek te beantwoorden. Conform de Verordening(EU) 2016 / 679 van het Europees Parlement en de Raad van 27 april 2016 beschikt u over een recht op inzage, rectificatie, beperkte verwerking en verwijdering van uw persoonsgegevens.<a href="https://faq-oesterreich.maisonsdumonde.com/mein-konto-und-personliche-daten/wie-kann-ich-meine-rechte-bezuglich-des-schutzes-meiner-personenbezogenen-daten-ausuben">Bij vragen kunt u klikken op deze link.</a> <a href="https://www.maisonsdumonde.com/BE/nl/statique/securite-et-confidentialite.htm">Ons verzamelbeleid en beleid inzake de verwerking van uw persoonlijke gegevens vindt u door op de volgende link te klikken.</a>',
  url: '/BE/nl/e/legal/credits-en-wettelijke-vermeldingen'
}, {
  language: 'de-CH',
  text: 'MAISONS DU MONDE SUISSE SARL nutzt Ihre personenbezogenen Daten, um auf Ihre Anfrage zu antworten. Nach der EU-Verordnung 2016/679 des Europäischen Parlaments und des Rates vom 27. April 2016 haben Sie das Recht auf Einsichtnahme, Berichtigung, Einschränkung und Löschung der Sie betreffenden Daten. <a href="https://faq-schweiz.maisonsdumonde.com/mein-konto-und-personliche-daten/wie-kann-ich-meine-rechte-bezuglich-des-schutzes-meiner-personenbezogenen-daten-ausuben">Sollten Sie dies wünschen, klicken Sie bitte hier.</a> <a href="https://www.maisonsdumonde.com/CH/de/statique/securite-et-confidentialite.htm">Weitere Informationen zur Verarbeitung Ihrer Daten finden Sie unter.</a>',
  url: '/CH/de/e/legal/bildnachweise-und-impressum'
}, {
  language: 'fr-CH',
  text: "MAISONS DU MONDE SUISSE SARL traite vos données personnelles pour répondre à votre demande. Conformément au Règlement (UE) 2016/679 du parlement Européen et du Conseil du 27 avril 2016, vous disposez d'un droit d'accès, de rectification, d'effacement et d'opposition de vos données personnelles ainsi qu'un droit à la limitation et à la portabilité de vos données. <a href=\"https://faq-suisse.maisonsdumonde.com/mon-compte-et-informations-personnelles/comment-puis-je-exercer-mes-droits-en-matiere-de-protection-de-mes-donnees-personnelles\">Vous pouvez exercer vos droits en cliquant sur ce lien.</a> <a href=\"https://www.maisonsdumonde.com/CH/fr/statique/securite-et-confidentialite.htm\">Concernant notre politique de collecte et traitement de vos données personnelles vous la trouverez en cliquant sur ce lien.</a>",
  url: '/CH/fr/e/legal/credits-et-mentions-legales'
}, {
  language: 'it-CH',
  text: 'MAISONS DU MONDE SUISSE SARL  tratta i suoi dati personali per rispondere alla sua richiesta. Conformemente al Regolamento (UE) 2016/679 del Parlamento europeo e del Consiglio del 27 aprile 2016, l\'utente dispone di un diritto di accesso, rettifica, limitazione e cancellazione dei propri dati personali. <a href="https://faq-svizzera.maisonsdumonde.com/il-mio-account-e-informazioni-personali/come-posso-esercitare-i-miei-diritti-nella-protezione-dei-miei-dati-personali">Per ulteriori informazioni sui tuoi dati personali, non esitare a contattarci cliccando su questo link.</a> <a href="https://www.maisonsdumonde.com/CH/it/statique/securite-et-confidentialite.htm">Puoi consultare qui la nostra informativa sulla privacy.</a>',
  url: '/CH/it/e/legal/crediti-e-menzioni-legali'
}, {
  language: 'fr-LU',
  text: "MAISONS DU MONDE LUXEMBOURG SARL traite vos données personnelles pour répondre à votre demande. Conformément au Règlement(UE) 2016 / 679 du parlement Européen et du Conseil du 27 avril 2016, vous disposez d'un droit d'accès, de rectification, d'effacement et d'opposition de vos données personnelles ainsi qu'un droit à la limitation et à la portabilité de vos données.<a href=\"https://faq-lux.maisonsdumonde.com/mon-compte-et-informations-personnelles/comment-puis-je-exercer-mes-droits-en-matiere-de-protection-de-mes-donnees-personnelles\">Vous pouvez exercer vos droits en cliquant sur ce lien.</a> <a href=\"https://www.maisonsdumonde.com/LU/fr/statique/securite-et-confidentialite.htm\">Concernant notre politique de protection des données personnelles vous la trouverez en cliquant sur ce lien.</a>",
  url: '/LU/fr/e/legal/credits-et-mentions-legales'
}, {
  language: 'nl-NL',
  text: 'MAISONS DU MONDE FRANCE SAS verwerkt uw persoonsgegevens om uw verzoek te beantwoorden. Conform de Verordening(EU) 2016 / 679 van het Europees Parlement en de Raad van 27 april 2016 beschikt u over een recht op inzage, rectificatie, beperkte verwerking en verwijdering van uw persoonsgegevens.<a href="https://faq-nederland.maisonsdumonde.com/mijn-account-en-persoonlijke-gegevens/hoe-kan-ik-mijn-rechten-uitoefenen-om-mijn-persoonlijke-gegevens-te-beschermen">Bij vragen kunt u klikken op deze link.</a> <a href="https://www.maisonsdumonde.com/NL/nl/statique/securite-et-confidentialite.htm">Ons verzamelbeleid en beleid inzake de verwerking van uw persoonlijke gegevens vindt u door op de volgende link te klikken.</a>',
  url: '/NL/nl/e/legal/credits-en-wettelijke-vermeldingen'
}, {
  language: 'pt-PT',
  text: 'MAISONS DU MONDE PORTUGAL recolhe e processa seus dados pessoais a fim de responder ao seu pedido. Em conformidade com o Regulamento(UE) 2016 / 679 do parlamento Europeu e do Conselho, de 27 de abril de 2016, dispõe do direito de acesso, de retificação, de eliminação e de oposição no que diz respeito aos seus dados pessoais, assim como do direito à limitação e à portabilidade dos seus dados. <a href="https://help-pt.maisonsdumonde.com/my-account-and-personal-information/how-do-i-exercise-my-rights-in-relation-to-my-personal-data">Pode também exercer o seu direito por meio da seguinte hiperligação.</a> <a href="https://www.maisonsdumonde.com/PT/pt/statique/securite-et-confidentialite.htm">Para encontrar a nossa política de recolha e de processamento dos seus dados pessoais, clique nesta hiperligação.</a>',
  url: '/PT/pt/e/legal/creditos-e-avisos-legais'
}, {
  language: 'en-GB',
  text: '"MDM UK FURNITURE & DECORATION LIMITED S.L processes your data in order to anwser your request. In accordance with the Regulation(EU) 2016 / 679 of the European Parliament and of the Council of 27 April 2016 you have the right to request the access to and rectification or erasure of your personal data or restriction of processing concerning the data subject or to object to processing as well as the right to data portability. <a href="https://help-uk.maisonsdumonde.com/my-account-and-personal-information/how-can-i-exercise-my-rights-for-my-personal-data">You can exercise your rights by clicking on this link.</a> <a href="https://www.maisonsdumonde.com/UK/en/e/legal/security-and-confidentiality">You can find our Personal data Protection Policy here</a>',
  url: '/UK/en/e/legal/credits-and-legal-notices'
}];
export var LEGAL_NOTICE_GDPR = [{
  language: 'fr-FR',
  text: "MAISONS DU MONDE FRANCE traite vos données personnelles pour répondre à votre demande. Conformément au Règlement(UE) 2016 / 679 du parlement Européen et du Conseil du 27 avril 2016, vous disposez d'un droit d'accès, de rectification, d'effacement et d'opposition de vos données personnelles ainsi qu'un droit à la limitation et à la portabilité de vos données.Vous pouvez exercer vos droits en remplissant les champs ci - dessus. <a href=\"https://www.maisonsdumonde.com/FR/fr/e/legal/securite-et-confidentialite\">Concernant notre politique de protection des données personnelles vous la trouverez en cliquant sur ce lien.</a>"
}, {
  language: 'es-ES',
  text: 'MAISONS DU MONDE ESPAÑA SL trata sus datos personales para responder a su solicitud. De Conformidad con el Reglamento(UE) 2016 / 679 del Parlamento Europeo y del Consejo del 27 de abril de 2016 usted dispone de un derecho de acceso, rectificación, limitación u oposición al tratamiento y supresión de sus datos personales, así como de portabilidad de los mismos, rellenando el formulario anterior. <a href="https://www.maisonsdumonde.com/ES/es/statique/securite-et-confidentialite.htm">Para conocer nuestra Política de Privacidad, visite la sección“ Datos Personales” en nuestra página web haciendo clic en este enlace.</a>'
}, {
  language: 'it-IT',
  text: '"MAISONS DU MONDE ITALIE S.P.A tratta i suoi dati personali per rispondere alla sua richiesta. Conformemente al Regolamento(UE) 2016 / 679 del Parlamento europeo e del Consiglio del 27 aprile 2016, l\'utente dispone di un diritto di accesso, rettifica, limitazione e cancellazione dei propri dati personali. <a href="https://www.maisonsdumonde.com/IT/it/statique/securite-et-confidentialite.htm">Puoi consultare qui la nostra informativa sulla privacy. Per ulteriori informazioni sui tuoi dati personali, non esitare a contattarci compilando il modulo sopra.</a>'
}, {
  language: 'de-DE',
  text: 'MAISONS DU MONDE ALLEMAGNE GmbH nutzt Ihre personenbezogenen Daten gem. Art. 6 Absatz 1 lit. b), c), f) Datenschutzgrundverordnung (DSGVO), um auf Ihre Anfrage zu antworten. Sie können bezüglich Ihrer bei uns verarbeiteten Daten gem. Art. 15-18, 20, 21 DSGVO jederzeit Auskunft, Berichtigung, Löschung, Beschränkung der Verarbeitung und Übertragung der Daten verlangen und der weiteren Verarbeitung jederzeit widersprechen. Für alle Anträge zur Geltendmachung Ihrer vorbezeichneten Rechte können Sie das Formular oben ausfüllenklicken. <a href="https://www.maisonsdumonde.com/DE/de/statique/securite-et-confidentialite.htm">Weitere Informationen zur Verarbeitung Ihrer Daten finden Sie unter.</a>'
}, {
  language: 'fr-BE',
  text: "MAISONS DU MONDE BELGIQUE SPRL traite vos données personnelles pour répondre à votre demande. Conformément au Règlement(UE) 2016 / 679 du parlement Européen et du Conseil du 27 avril 2016, vous disposez d'un droit d'accès, de rectification, d'effacement et d'opposition de vos données personnelles ainsi qu'un droit à la limitation et à la portabilité de vos données.Vous pouvez exercer vos droits en remplissant les champs ci - dessus. <a href=\"https://www.maisonsdumonde.com/BE/fr/statique/securite-et-confidentialite.htm\">Concernant notre politique de protection des données personnelles vous la trouverez en cliquant sur ce lien.</a>"
}, {
  language: 'de-AT',
  text: 'MAISONS DU MONDE ÖSTERREICH nutzt Ihre personenbezogenen Daten gem. Art. 6 Absatz 1 lit. b), c), f) Datenschutzgrundverordnung (DSGVO), um auf Ihre Anfrage zu antworten. Sie können bezüglich Ihrer bei uns verarbeiteten Daten gem. Art. 15-18, 20, 21 DSGVO jederzeit Auskunft, Berichtigung, Löschung, Beschränkung der Verarbeitung und Übertragung der Daten verlangen und der weiteren Verarbeitung jederzeit widersprechen. Für alle Anträge zur Geltendmachung Ihrer vorbezeichneten Rechte können Sie das Formular oben ausfüllenklicken. <a href="https://www.maisonsdumonde.com/AT/de/statique/securite-et-confidentialite.htm">Weitere Informationen zur Verarbeitung Ihrer Daten finden Sie unter.</a>'
}, {
  language: 'nl-BE',
  text: 'MAISONS DU MONDE BELGIQUE SPRL verwerkt uw persoonsgegevens om uw verzoek te beantwoorden. Conform de Verordening(EU) 2016 / 679 van het Europees Parlement en de Raad van 27 april 2016 beschikt u over een recht op inzage, rectificatie, beperkte verwerking en verwijdering van uw persoonsgegevens.Bij vragen kunt u door het bovenstaande formulier in te vullen. <a href="https://www.maisonsdumonde.com/BE/nl/statique/securite-et-confidentialite.htm">Ons verzamelbeleid en beleid inzake de verwerking van uw persoonlijke gegevens vindt u door op de volgende link te klikken.</a>'
}, {
  language: 'de-CH',
  text: 'MAISONS DU MONDE SUISSE SARL nutzt Ihre personenbezogenen Daten, um auf Ihre Anfrage zu antworten. Nach der EU-Verordnung 2016/679 des Europäischen Parlaments und des Rates vom 27. April 2016 haben Sie das Recht auf Einsichtnahme, Berichtigung, Einschränkung und Löschung der Sie betreffenden Daten. Für alle Anträge zur Geltendmachung Ihrer vorbezeichneten Rechte können Sie das Formular oben ausfüllenklicken. <a href="https://www.maisonsdumonde.com/CH/de/statique/securite-et-confidentialite.htm">Weitere Informationen zur Verarbeitung Ihrer Daten finden Sie unter.</a>'
}, {
  language: 'fr-CH',
  text: "MAISONS DU MONDE SUISSE SARL traite vos données personnelles pour répondre à votre demande. Conformément au Règlement (UE) 2016/679 du parlement Européen et du Conseil du 27 avril 2016, vous disposez d'un droit d'accès, de rectification, d'effacement et d'opposition de vos données personnelles ainsi qu’un droit à la limitation et à la portabilité de vos données. Vous pouvez exercer vos droits en remplissant les champs ci-dessus. <a href=\"https://www.maisonsdumonde.com/CH/fr/statique/securite-et-confidentialite.htm\">Concernant notre politique de collecte et traitement de vos données personnelles vous la trouverez en cliquant sur ce lien.</a>"
}, {
  language: 'it-CH',
  text: 'MAISONS DU MONDE SUISSE SARL  tratta i suoi dati personali per rispondere alla sua richiesta. Conformemente al Regolamento (UE) 2016/679 del Parlamento europeo e del Consiglio del 27 aprile 2016, l\'utente dispone di un diritto di accesso, rettifica, limitazione e cancellazione dei propri dati personali.Per ulteriori informazioni sui tuoi dati personali, non esitare a contattarci compilando il modulo sopra. <a href="https://www.maisonsdumonde.com/CH/it/statique/securite-et-confidentialite.htm">Puoi consultare qui la nostra informativa sulla privacy.</a>'
}, {
  language: 'fr-LU',
  text: "MAISONS DU MONDE LUXEMBOURG SARL traite vos données personnelles pour répondre à votre demande. Conformément au Règlement(UE) 2016 / 679 du parlement Européen et du Conseil du 27 avril 2016, vous disposez d'un droit d'accès, de rectification, d'effacement et d'opposition de vos données personnelles ainsi qu'un droit à la limitation et à la portabilité de vos données.Vous pouvez exercer vos droits en remplissant les champs ci - dessus. <a href=\"https://www.maisonsdumonde.com/LU/fr/statique/securite-et-confidentialite.htm\">Concernant notre politique de protection des données personnelles vous la trouverez en cliquant sur ce lien.</a>"
}, {
  language: 'nl-NL',
  text: 'MAISONS DU MONDE FRANCE SAS verwerkt uw persoonsgegevens om uw verzoek te beantwoorden. Conform de Verordening(EU) 2016 / 679 van het Europees Parlement en de Raad van 27 april 2016 beschikt u over een recht op inzage, rectificatie, beperkte verwerking en verwijdering van uw persoonsgegevens.Bij vragen kunt u door het bovenstaande formulier in te vullen. <a href="https://www.maisonsdumonde.com/NL/nl/statique/securite-et-confidentialite.htm">Ons verzamelbeleid en beleid inzake de verwerking van uw persoonlijke gegevens vindt u door op de volgende link te klikken.</a>'
}, {
  language: 'pt-PT',
  text: 'MAISONS DU MONDE PORTUGAL recolhe e processa seus dados pessoais a fim de responder ao seu pedido. Em conformidade com o Regulamento(UE) 2016 / 679 do parlamento Europeu e do Conselho, de 27 de abril de 2016, dispõe do direito de acesso, de retificação, de eliminação e de oposição no que diz respeito aos seus dados pessoais, assim como do direito à limitação e à portabilidade dos seus dados.Pode também exercer o seu direito preenchendo o formulário acima. <a href="https://www.maisonsdumonde.com/PT/pt/statique/securite-et-confidentialite.htm">Para encontrar a nossa política de recolha e de processamento dos seus dados pessoais, clique nesta hiperligação.</a>'
}, {
  language: 'en-GB',
  text: 'MDM UK FURNITURE & DECORATION LIMITED S.L processes your data in order to anwser your request. In accordance with the Regulation(EU) 2016 / 679 of the European Parliament and of the Council of 27 April 2016 you have the right to request the access to and rectification or erasure of your personal data or restriction of processing concerning the data subject or to object to processing as well as the right to data portability.You can exercise your rights by filling the form above. <a href="https://www.maisonsdumonde.com/UK/en/e/legal/security-and-confidentiality">You can find our Personal data Protection Policy here.</a>'
}];
export var PRIVACY_POLICY = [{
  language: 'fr-FR',
  url: '/FR/fr/e/legal/securite-et-confidentialite'
}, {
  language: 'es-ES',
  url: '/ES/es/e/legal/seguridad-y-confidencialidad'
}, {
  language: 'it-IT',
  url: '/IT/it/e/legal/sicurezza-e-riservatezza'
}, {
  language: 'de-DE',
  url: '/DE/de/e/legal/datenschutz'
}, {
  language: 'fr-BE',
  url: '/BE/fr/e/legal/securite-et-confidentialite'
}, {
  language: 'de-AT',
  url: '/AT/de/e/legal/datenschutz'
}, {
  language: 'nl-BE',
  url: '/BE/nl/e/legal/veiligheid-en-vertrouwelijkheid'
}, {
  language: 'de-CH',
  url: '/CH/de/e/legal/datenschutz'
}, {
  language: 'fr-CH',
  url: '/CH/fr/e/legal/securite-et-confidentialite'
}, {
  language: 'it-CH',
  url: '/CH/it/e/legal/sicurezza-e-riservatezza'
}, {
  language: 'fr-LU',
  url: '/LU/fr/e/legal/securite-et-confidentialite'
}, {
  language: 'nl-NL',
  url: '/NL/nl/e/legal/veiligheid-en-vertrouwelijkheid'
}, {
  language: 'pt-PT',
  url: '/PT/pt/e/legal/seguranca-e-confidencialidade'
}, {
  language: 'en-GB',
  url: '/UK/en/e/legal/security-and-confidentiality'
}];
export var CUSTOMER_REVIEWS = [{
  language: 'fr-FR',
  url: '/FR/fr/e/legal/avis-clients'
}, {
  language: 'es-ES',
  url: '/ES/es/e/legal/opiniones-de-otros-clientes'
}, {
  language: 'it-IT',
  url: '/IT/it/e/legal/feedback-clienti'
}, {
  language: 'de-DE',
  url: '/DE/de/e/legal/kundenbewertungen'
}, {
  language: 'fr-BE',
  url: '/BE/fr/e/legal/avis-clients'
}, {
  language: 'de-AT',
  url: '/AT/de/e/legal/kundenbewertungen'
}, {
  language: 'nl-BE',
  url: '/BE/nl/e/legal/reviews-van-klanten'
}, {
  language: 'de-CH',
  url: '/CH/de/e/legal/kundenbewertungen'
}, {
  language: 'fr-CH',
  url: '/CH/fr/e/legal/avis-clients'
}, {
  language: 'it-CH',
  url: '/CH/it/e/legal/feedback-clienti'
}, {
  language: 'fr-LU',
  url: '/LU/fr/e/legal/avis-clients'
}, {
  language: 'nl-NL',
  url: '/NL/nl/e/legal/reviews-van-klanten'
}, {
  language: 'pt-PT',
  url: '/PT/pt/e/legal/opinioes-dos-clientes'
}, {
  language: 'en-GB',
  url: '/UK/en/e/legal/customer-reviews'
}];
export var CGU = [{
  language: 'fr-FR',
  links: [{
    label: 'Classement Référencement des Offres - ',
    url: '/FR/fr/e/legal/classement-referencement-offres'
  }, {
    label: 'CGU Marketplace - ',
    url: '/FR/fr/e/legal/cgu-acheteurs-marketplace'
  }, {
    label: 'CGU Marketplace BUSINESS - ',
    url: '/FR/fr/e/legal/cgu-acheteurs-marketplace-business'
  }]
}, {
  language: 'es-ES',
  links: [{
    label: 'Clasificación de las ofertas - ',
    url: '/ES/es/e/legal/clasificacion-posicionamiento-ofertas'
  }, {
    label: 'Términos y condiciones de uso del marketplace - ',
    url: '/ES/es/e/legal/cgu-compradores-marketplace'
  }, {
    label: 'Términos y condiciones de uso del marketplace para negocios - ',
    url: '/ES/es/e/legal/cgu-compradores-marketplace-business'
  }]
}, {
  language: 'it-IT',
  links: [{
    label: "Classificazione dell'offerta prodotti - ",
    url: '/IT/it/e/legal/classificazione-offerta-prodotti'
  }, {
    label: 'CGU Marketplace - ',
    url: '/IT/it/e/legal/cgu-marketplace'
  }, {
    label: 'CGU Marketplace Business - ',
    url: '/IT/it/e/legal/cgu-marketplace-business'
  }]
}, {
  language: 'fr-BE',
  links: [{
    label: 'Classement Référencement Offres - ',
    url: '/BE/fr/e/legal/classement-referencement-offres'
  }, {
    label: 'CGU Marketplace - ',
    url: '/BE/fr/e/legal/cgu-acheteurs-marketplace'
  }, {
    label: 'CGU Marketplace BUSINESS - ',
    url: '/BE/fr/e/legal/cgu-acheteurs-marketplace-business'
  }]
}, {
  language: 'nl-BE',
  links: [{
    label: 'Rangschikking aanbiedingen - '
  }, {
    label: 'Algemene verkoopsvoorwaarden Marketplace - '
  }, {
    label: 'Algemene verkoopsvoorwaarden Marketplace Business - '
  }]
}, {
  language: 'de-DE',
  links: [{
    label: 'Ranking und Listing von Angeboten - ',
    url: '/DE/de/e/legal/regelung-auflistung-angebote'
  }, {
    label: 'AGB Marketplace - ',
    url: '/DE/de/e/legal/agb-verkäufer-marketplace'
  }, {
    label: 'AGB Marketplace Geschäftskunden - ',
    url: '/DE/de/e/legal/agb-verkäufer-marketplace-business'
  }]
}, {
  language: 'fr-LU',
  links: [{
    label: 'Classement Référencement Offres - ',
    url: '/LU/fr/e/legal/classement-referencement-offres'
  }, {
    label: 'CGU Marketplace - ',
    url: '/LU/fr/e/legal/cgu-acheteurs-marketplace'
  }, {
    label: 'CGU Marketplace BUSINESS - ',
    url: '/LU/fr/e/legal/cgu-acheteurs-marketplace-business'
  }]
}, {
  language: 'nl-NL',
  links: [{
    label: 'Rangschikking aanbiedingen - '
  }, {
    label: 'Algemene verkoopsvoorwaarden Marketplace - '
  }, {
    label: 'Algemene verkoopsvoorwaarden Marketplace Business - '
  }]
}, {
  language: 'de-AT',
  links: [{
    label: 'Ranking und Listing von Angeboten - '
  }, {
    label: 'AGB Marketplace - '
  }, {
    label: 'AGB Marketplace Geschäftskunden - '
  }]
}, {
  language: 'pt-PT',
  links: [{
    label: 'Classificação da publicitação de ofertas - '
  }, {
    label: 'CGU do Marketplace - '
  }, {
    label: 'CGU do Marketplace Business - '
  }]
}, {
  language: 'de-CH',
  links: [{
    label: 'Ranking und Listing von Angeboten - '
  }, {
    label: 'AGB Marketplace - '
  }, {
    label: 'AGB Marketplace Geschäftskunden - '
  }]
}, {
  language: 'it-CH',
  links: [{
    label: "Classificazione dell'offerta prodotti - ",
    url: '/CH/it/e/legal/classificazione-offerta-prodotti'
  }, {
    label: 'CGU Marketplace - ',
    url: '/CH/it/e/legal/cgu-marketplace'
  }, {
    label: 'CGU Marketplace Business - ',
    url: '/CH/it/e/legal/cgu-marketplace-business'
  }]
}, {
  language: 'fr-CH',
  links: [{
    label: 'Classement Référencement Offres - ',
    url: '/CH/fr/e/legal/classement-referencement-offres'
  }, {
    label: 'CGU Marketplace - ',
    url: '/CH/fr/e/legal/cgu-acheteurs-marketplace'
  }, {
    label: 'CGU Marketplace BUSINESS - ',
    url: '/CH/fr/e/legal/cgu-acheteurs-marketplace-business'
  }]
}, {
  language: 'en-GB',
  links: [{
    label: 'Listing and classifying items - '
  }, {
    label: 'Marketplace T&Cs - '
  }, {
    label: 'Business Marketplace T&Cs - '
  }]
}];
export var ORDER_RETURN = [{
  language: 'fr-FR',
  url: "".concat(FAQ_URL['fr-FR'], "/fr/articles/5595578-je-souhaite-annuler-ou-modifier-ma-commande")
}, {
  language: 'fr-BE',
  url: "".concat(FAQ_URL['fr-BE'], "/fr/articles/5595578-je-souhaite-annuler-ou-modifier-ma-commande")
}, {
  language: 'en-GB',
  url: "".concat(FAQ_URL['en-GB'], "/en/articles/2436295-i-want-to-cancel-or-change-my-order")
}, {
  language: 'de-DE',
  url: "".concat(FAQ_URL['de-DE'], "/de/articles/5756570-ich-mochte-meine-bestellung-stornieren-oder-andern")
}, {
  language: 'de-AT',
  url: "".concat(FAQ_URL['de-AT'], "/de/articles/5756570-ich-mochte-meine-bestellung-stornieren-oder-andern")
}, {
  language: 'es-ES',
  url: "".concat(FAQ_URL['es-ES'], "/es/articles/5756579-deseo-cancelar-o-modificar-mi-pedido")
}, {
  language: 'it-IT',
  url: "".concat(FAQ_URL['it-IT'], "/it/articles/5756576-desidero-cancellare-o-modificare-il-mio-ordine")
}, {
  language: 'it-CH',
  url: "".concat(FAQ_URL['it-CH'], "/it/articles/5756576-desidero-cancellare-o-modificare-il-mio-ordine")
}];
var returnEndpointLinks = {
  fr_FR: 'https://faq-france.',
  nl_BE: 'https://faq-belgie.',
  fr_BE: 'https://faq-belgique.',
  de_DE: 'https://faq-deutschland.',
  es_ES: 'https://faq-es.',
  it_IT: 'https://faq-italia.',
  fr_LU: 'https://faq-lux.',
  nl_NL: 'https://faq-nederland.',
  de_AT: 'https://faq-oesterreich.',
  pt_PT: 'https://help-pt.',
  de_CH: 'https://faq-schweiz.',
  it_CH: 'https://faq-svizzera.',
  fr_CH: 'https://faq-suisse.',
  en_UK: 'https://help-uk.',
  en_GB: 'https://help-uk.'
};
var returnLinks = {
  fr_FR: '1235271-retour-et-remboursement',
  nl_BE: '1464319-retourneren-en-terugbetaling',
  fr_BE: '1410739-retour-et-remboursement',
  de_DE: '1462573-retouren-und-erstattungen',
  es_ES: '1440576-devolucion-y-reembolso',
  it_IT: '1433177-resi-e-rimborsi',
  fr_LU: '1474497-retour-et-remboursement',
  nl_NL: '1469867-retourneren-en-terugbetaling',
  de_AT: '1471424-retouren-und-erstattungen',
  pt_PT: '1472887-devolucao-e-reembolso',
  de_CH: '1466199-retouren-und-erstattungen',
  it_CH: '1460838-resi-e-rimborsi',
  fr_CH: '1413252-retour-et-remboursement',
  en_UK: '1223125-refunds-returns',
  en_GB: '1223125-refunds-returns'
};
var deliveryLinks = {
  fr_FR: 'service-retrait-magasin',
  es_ES: 'https://www.maisonsdumonde.com/ES/es/livraison-magasin.htm',
  it_IT: 'https://www.maisonsdumonde.com/IT/it/livraison-magasin.htm'
};
var getDeliveryLinks = function getDeliveryLinks(locale) {
  var lang = "".concat(locale.language, "_").concat(locale.market);
  var path = deliveryLinks[lang];
  if (path.includes('maisonsdumonde')) {
    return deliveryLinks[lang];
  }
  return "/".concat(locale.market, "/").concat(locale.language, "/e/").concat(path);
};
var getReturnsLinks = function getReturnsLinks(locale) {
  var lang = "".concat(locale.language, "_").concat(locale.market);
  var endpoint = returnEndpointLinks[lang];
  var path = returnLinks[lang];
  return "".concat(endpoint, "maisonsdumonde.com/").concat(locale.language, "/collections/").concat(path);
};
var getFaqLinks = function getFaqLinks(locale) {
  var lang = "".concat(locale.language, "_").concat(locale.market);
  var endpoint = returnEndpointLinks[lang];
  console.log("".concat(endpoint, "maisonsdumonde.com/").concat(locale.language, "/"));
  return "".concat(endpoint, "maisonsdumonde.com/").concat(locale.language, "/");
};
export { getDeliveryLinks, getReturnsLinks, getFaqLinks };